"use strict";

function _interopDefault(e) {
  return e && "object" == typeof e && "default" in e ? e.default : e;
}

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var React = require("react"),
    React__default = _interopDefault(React),
    styled = require("styled-components"),
    styled__default = _interopDefault(styled);

function _typeof(e) {
  return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  })(e);
}

function _defineProperty(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}

function _extends() {
  return (_extends = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }

    return e;
  }).apply(this, arguments);
}

function ownKeys(t, e) {
  var n = Object.keys(t);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function (e) {
      return Object.getOwnPropertyDescriptor(t, e).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function _objectSpread2(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = null != arguments[e] ? arguments[e] : {};
    e % 2 ? ownKeys(Object(n), !0).forEach(function (e) {
      _defineProperty(t, e, n[e]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : ownKeys(Object(n)).forEach(function (e) {
      Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
    });
  }

  return t;
}

function _taggedTemplateLiteral(e, t) {
  return t = t || e.slice(0), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}

function _slicedToArray(e, t) {
  return _arrayWithHoles(e) || _iterableToArrayLimit(e, t) || _unsupportedIterableToArray(e, t) || _nonIterableRest();
}

function _toConsumableArray(e) {
  return _arrayWithoutHoles(e) || _iterableToArray(e) || _unsupportedIterableToArray(e) || _nonIterableSpread();
}

function _arrayWithoutHoles(e) {
  if (Array.isArray(e)) return _arrayLikeToArray(e);
}

function _arrayWithHoles(e) {
  if (Array.isArray(e)) return e;
}

function _iterableToArray(e) {
  if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) return Array.from(e);
}

function _iterableToArrayLimit(e, t) {
  if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) {
    var n = [],
        r = !0,
        o = !1,
        a = void 0;

    try {
      for (var l, i = e[Symbol.iterator](); !(r = (l = i.next()).done) && (n.push(l.value), !t || n.length !== t); r = !0) {
        ;
      }
    } catch (e) {
      o = !0, a = e;
    } finally {
      try {
        r || null == i.return || i.return();
      } finally {
        if (o) throw a;
      }
    }

    return n;
  }
}

function _unsupportedIterableToArray(e, t) {
  if (e) {
    if ("string" == typeof e) return _arrayLikeToArray(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? _arrayLikeToArray(e, t) : void 0;
  }
}

function _arrayLikeToArray(e, t) {
  (null == t || t > e.length) && (t = e.length);

  for (var n = 0, r = new Array(t); n < t; n++) {
    r[n] = e[n];
  }

  return r;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var commonjsGlobal = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};

function unwrapExports(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}

function createCommonjsModule(e, t) {
  return e(t = {
    exports: {}
  }, t.exports), t.exports;
}

var reactIs_production_min = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var n = "function" == typeof Symbol && Symbol.for,
      r = n ? Symbol.for("react.element") : 60103,
      o = n ? Symbol.for("react.portal") : 60106,
      a = n ? Symbol.for("react.fragment") : 60107,
      l = n ? Symbol.for("react.strict_mode") : 60108,
      i = n ? Symbol.for("react.profiler") : 60114,
      c = n ? Symbol.for("react.provider") : 60109,
      p = n ? Symbol.for("react.context") : 60110,
      s = n ? Symbol.for("react.async_mode") : 60111,
      u = n ? Symbol.for("react.concurrent_mode") : 60111,
      d = n ? Symbol.for("react.forward_ref") : 60112,
      f = n ? Symbol.for("react.suspense") : 60113,
      y = n ? Symbol.for("react.suspense_list") : 60120,
      m = n ? Symbol.for("react.memo") : 60115,
      b = n ? Symbol.for("react.lazy") : 60116,
      _ = n ? Symbol.for("react.fundamental") : 60117,
      g = n ? Symbol.for("react.responder") : 60118,
      h = n ? Symbol.for("react.scope") : 60119;

  function v(e) {
    if ("object" == typeof e && null !== e) {
      var t = e.$$typeof;

      switch (t) {
        case r:
          switch (e = e.type) {
            case s:
            case u:
            case a:
            case i:
            case l:
            case f:
              return e;

            default:
              switch (e = e && e.$$typeof) {
                case p:
                case d:
                case b:
                case m:
                case c:
                  return e;

                default:
                  return t;
              }

          }

        case o:
          return t;
      }
    }
  }

  function T(e) {
    return v(e) === u;
  }

  t.typeOf = v, t.AsyncMode = s, t.ConcurrentMode = u, t.ContextConsumer = p, t.ContextProvider = c, t.Element = r, t.ForwardRef = d, t.Fragment = a, t.Lazy = b, t.Memo = m, t.Portal = o, t.Profiler = i, t.StrictMode = l, t.Suspense = f, t.isValidElementType = function (e) {
    return "string" == typeof e || "function" == typeof e || e === a || e === u || e === i || e === l || e === f || e === y || "object" == typeof e && null !== e && (e.$$typeof === b || e.$$typeof === m || e.$$typeof === c || e.$$typeof === p || e.$$typeof === d || e.$$typeof === _ || e.$$typeof === g || e.$$typeof === h);
  }, t.isAsyncMode = function (e) {
    return T(e) || v(e) === s;
  }, t.isConcurrentMode = T, t.isContextConsumer = function (e) {
    return v(e) === p;
  }, t.isContextProvider = function (e) {
    return v(e) === c;
  }, t.isElement = function (e) {
    return "object" == typeof e && null !== e && e.$$typeof === r;
  }, t.isForwardRef = function (e) {
    return v(e) === d;
  }, t.isFragment = function (e) {
    return v(e) === a;
  }, t.isLazy = function (e) {
    return v(e) === b;
  }, t.isMemo = function (e) {
    return v(e) === m;
  }, t.isPortal = function (e) {
    return v(e) === o;
  }, t.isProfiler = function (e) {
    return v(e) === i;
  }, t.isStrictMode = function (e) {
    return v(e) === l;
  }, t.isSuspense = function (e) {
    return v(e) === f;
  };
});
unwrapExports(reactIs_production_min);
var reactIs_production_min_1 = reactIs_production_min.typeOf,
    reactIs_production_min_2 = reactIs_production_min.AsyncMode,
    reactIs_production_min_3 = reactIs_production_min.ConcurrentMode,
    reactIs_production_min_4 = reactIs_production_min.ContextConsumer,
    reactIs_production_min_5 = reactIs_production_min.ContextProvider,
    reactIs_production_min_6 = reactIs_production_min.Element,
    reactIs_production_min_7 = reactIs_production_min.ForwardRef,
    reactIs_production_min_8 = reactIs_production_min.Fragment,
    reactIs_production_min_9 = reactIs_production_min.Lazy,
    reactIs_production_min_10 = reactIs_production_min.Memo,
    reactIs_production_min_11 = reactIs_production_min.Portal,
    reactIs_production_min_12 = reactIs_production_min.Profiler,
    reactIs_production_min_13 = reactIs_production_min.StrictMode,
    reactIs_production_min_14 = reactIs_production_min.Suspense,
    reactIs_production_min_15 = reactIs_production_min.isValidElementType,
    reactIs_production_min_16 = reactIs_production_min.isAsyncMode,
    reactIs_production_min_17 = reactIs_production_min.isConcurrentMode,
    reactIs_production_min_18 = reactIs_production_min.isContextConsumer,
    reactIs_production_min_19 = reactIs_production_min.isContextProvider,
    reactIs_production_min_20 = reactIs_production_min.isElement,
    reactIs_production_min_21 = reactIs_production_min.isForwardRef,
    reactIs_production_min_22 = reactIs_production_min.isFragment,
    reactIs_production_min_23 = reactIs_production_min.isLazy,
    reactIs_production_min_24 = reactIs_production_min.isMemo,
    reactIs_production_min_25 = reactIs_production_min.isPortal,
    reactIs_production_min_26 = reactIs_production_min.isProfiler,
    reactIs_production_min_27 = reactIs_production_min.isStrictMode,
    reactIs_production_min_28 = reactIs_production_min.isSuspense,
    reactIs_development = createCommonjsModule(function (e, L) {
  "production" !== process.env.NODE_ENV && function () {
    Object.defineProperty(L, "__esModule", {
      value: !0
    });

    var e = "function" == typeof Symbol && Symbol.for,
        o = e ? Symbol.for("react.element") : 60103,
        a = e ? Symbol.for("react.portal") : 60106,
        l = e ? Symbol.for("react.fragment") : 60107,
        i = e ? Symbol.for("react.strict_mode") : 60108,
        c = e ? Symbol.for("react.profiler") : 60114,
        p = e ? Symbol.for("react.provider") : 60109,
        s = e ? Symbol.for("react.context") : 60110,
        u = e ? Symbol.for("react.async_mode") : 60111,
        d = e ? Symbol.for("react.concurrent_mode") : 60111,
        f = e ? Symbol.for("react.forward_ref") : 60112,
        y = e ? Symbol.for("react.suspense") : 60113,
        t = e ? Symbol.for("react.suspense_list") : 60120,
        m = e ? Symbol.for("react.memo") : 60115,
        b = e ? Symbol.for("react.lazy") : 60116,
        n = e ? Symbol.for("react.fundamental") : 60117,
        r = e ? Symbol.for("react.responder") : 60118,
        _ = e ? Symbol.for("react.scope") : 60119;

    var g = function g(e, t) {
      if (void 0 === t) throw new Error("`lowPriorityWarningWithoutStack(condition, format, ...args)` requires a warning message argument");

      if (!e) {
        for (var n = arguments.length, r = new Array(2 < n ? n - 2 : 0), o = 2; o < n; o++) {
          r[o - 2] = arguments[o];
        }

        (function (e) {
          for (var t = arguments.length, n = new Array(1 < t ? t - 1 : 0), r = 1; r < t; r++) {
            n[r - 1] = arguments[r];
          }

          var o = 0,
              a = "Warning: " + e.replace(/%s/g, function () {
            return n[o++];
          });
          "undefined" != typeof console && console.warn(a);

          try {
            throw new Error(a);
          } catch (e) {}
        }).apply(void 0, [t].concat(r));
      }
    };

    function h(e) {
      if ("object" == typeof e && null !== e) {
        var t = e.$$typeof;

        switch (t) {
          case o:
            var n = e.type;

            switch (n) {
              case u:
              case d:
              case l:
              case c:
              case i:
              case y:
                return n;

              default:
                var r = n && n.$$typeof;

                switch (r) {
                  case s:
                  case f:
                  case b:
                  case m:
                  case p:
                    return r;

                  default:
                    return t;
                }

            }

          case a:
            return t;
        }
      }
    }

    var v = u,
        T = d,
        w = s,
        R = p,
        x = o,
        O = f,
        S = l,
        j = b,
        C = m,
        E = a,
        P = c,
        I = i,
        $ = y,
        k = !1;

    function A(e) {
      return h(e) === d;
    }

    L.typeOf = h, L.AsyncMode = v, L.ConcurrentMode = T, L.ContextConsumer = w, L.ContextProvider = R, L.Element = x, L.ForwardRef = O, L.Fragment = S, L.Lazy = j, L.Memo = C, L.Portal = E, L.Profiler = P, L.StrictMode = I, L.Suspense = $, L.isValidElementType = function (e) {
      return "string" == typeof e || "function" == typeof e || e === l || e === d || e === c || e === i || e === y || e === t || "object" == typeof e && null !== e && (e.$$typeof === b || e.$$typeof === m || e.$$typeof === p || e.$$typeof === s || e.$$typeof === f || e.$$typeof === n || e.$$typeof === r || e.$$typeof === _);
    }, L.isAsyncMode = function (e) {
      return k || g(!(k = !0), "The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API."), A(e) || h(e) === u;
    }, L.isConcurrentMode = A, L.isContextConsumer = function (e) {
      return h(e) === s;
    }, L.isContextProvider = function (e) {
      return h(e) === p;
    }, L.isElement = function (e) {
      return "object" == typeof e && null !== e && e.$$typeof === o;
    }, L.isForwardRef = function (e) {
      return h(e) === f;
    }, L.isFragment = function (e) {
      return h(e) === l;
    }, L.isLazy = function (e) {
      return h(e) === b;
    }, L.isMemo = function (e) {
      return h(e) === m;
    }, L.isPortal = function (e) {
      return h(e) === a;
    }, L.isProfiler = function (e) {
      return h(e) === c;
    }, L.isStrictMode = function (e) {
      return h(e) === i;
    }, L.isSuspense = function (e) {
      return h(e) === y;
    };
  }();
});
unwrapExports(reactIs_development);
var reactIs_development_1 = reactIs_development.typeOf,
    reactIs_development_2 = reactIs_development.AsyncMode,
    reactIs_development_3 = reactIs_development.ConcurrentMode,
    reactIs_development_4 = reactIs_development.ContextConsumer,
    reactIs_development_5 = reactIs_development.ContextProvider,
    reactIs_development_6 = reactIs_development.Element,
    reactIs_development_7 = reactIs_development.ForwardRef,
    reactIs_development_8 = reactIs_development.Fragment,
    reactIs_development_9 = reactIs_development.Lazy,
    reactIs_development_10 = reactIs_development.Memo,
    reactIs_development_11 = reactIs_development.Portal,
    reactIs_development_12 = reactIs_development.Profiler,
    reactIs_development_13 = reactIs_development.StrictMode,
    reactIs_development_14 = reactIs_development.Suspense,
    reactIs_development_15 = reactIs_development.isValidElementType,
    reactIs_development_16 = reactIs_development.isAsyncMode,
    reactIs_development_17 = reactIs_development.isConcurrentMode,
    reactIs_development_18 = reactIs_development.isContextConsumer,
    reactIs_development_19 = reactIs_development.isContextProvider,
    reactIs_development_20 = reactIs_development.isElement,
    reactIs_development_21 = reactIs_development.isForwardRef,
    reactIs_development_22 = reactIs_development.isFragment,
    reactIs_development_23 = reactIs_development.isLazy,
    reactIs_development_24 = reactIs_development.isMemo,
    reactIs_development_25 = reactIs_development.isPortal,
    reactIs_development_26 = reactIs_development.isProfiler,
    reactIs_development_27 = reactIs_development.isStrictMode,
    reactIs_development_28 = reactIs_development.isSuspense,
    reactIs = createCommonjsModule(function (e) {
  "production" === process.env.NODE_ENV ? e.exports = reactIs_production_min : e.exports = reactIs_development;
}),
    getOwnPropertySymbols = Object.getOwnPropertySymbols,
    hasOwnProperty = Object.prototype.hasOwnProperty,
    propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(e) {
  if (null == e) throw new TypeError("Object.assign cannot be called with null or undefined");
  return Object(e);
}

function shouldUseNative() {
  try {
    if (!Object.assign) return !1;
    var e = new String("abc");
    if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;

    for (var t = {}, n = 0; n < 10; n++) {
      t["_" + String.fromCharCode(n)] = n;
    }

    if ("0123456789" !== Object.getOwnPropertyNames(t).map(function (e) {
      return t[e];
    }).join("")) return !1;
    var r = {};
    return "abcdefghijklmnopqrst".split("").forEach(function (e) {
      r[e] = e;
    }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, r)).join("");
  } catch (e) {
    return !1;
  }
}

var objectAssign = shouldUseNative() ? Object.assign : function (e, t) {
  for (var n, r, o = toObject(e), a = 1; a < arguments.length; a++) {
    for (var l in n = Object(arguments[a])) {
      hasOwnProperty.call(n, l) && (o[l] = n[l]);
    }

    if (getOwnPropertySymbols) {
      r = getOwnPropertySymbols(n);

      for (var i = 0; i < r.length; i++) {
        propIsEnumerable.call(n, r[i]) && (o[r[i]] = n[r[i]]);
      }
    }
  }

  return o;
},
    ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED",
    ReactPropTypesSecret_1 = ReactPropTypesSecret,
    printWarning = function printWarning() {};

if ("production" !== process.env.NODE_ENV) {
  var ReactPropTypesSecret$1 = ReactPropTypesSecret_1,
      loggedTypeFailures = {},
      has = Function.call.bind(Object.prototype.hasOwnProperty);

  printWarning = function printWarning(e) {
    var t = "Warning: " + e;
    "undefined" != typeof console && console.error(t);

    try {
      throw new Error(t);
    } catch (e) {}
  };
}

function checkPropTypes(e, t, n, r, o) {
  if ("production" !== process.env.NODE_ENV) for (var a in e) {
    if (has(e, a)) {
      var l;

      try {
        if ("function" != typeof e[a]) {
          var i = Error((r || "React class") + ": " + n + " type `" + a + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[a] + "`.");
          throw i.name = "Invariant Violation", i;
        }

        l = e[a](t, a, r, n, null, ReactPropTypesSecret$1);
      } catch (e) {
        l = e;
      }

      if (!l || l instanceof Error || printWarning((r || "React class") + ": type specification of " + n + " `" + a + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof l + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), l instanceof Error && !(l.message in loggedTypeFailures)) {
        loggedTypeFailures[l.message] = !0;
        var c = o ? o() : "";
        printWarning("Failed " + n + " type: " + l.message + (null != c ? c : ""));
      }
    }
  }
}

checkPropTypes.resetWarningCache = function () {
  "production" !== process.env.NODE_ENV && (loggedTypeFailures = {});
};

var checkPropTypes_1 = checkPropTypes,
    has$1 = Function.call.bind(Object.prototype.hasOwnProperty),
    printWarning$1 = function printWarning$1() {};

function emptyFunctionThatReturnsNull() {
  return null;
}

"production" !== process.env.NODE_ENV && (printWarning$1 = function printWarning$1(e) {
  var t = "Warning: " + e;
  "undefined" != typeof console && console.error(t);

  try {
    throw new Error(t);
  } catch (e) {}
});

var factoryWithTypeCheckers = function factoryWithTypeCheckers(l, d) {
  var a = "function" == typeof Symbol && Symbol.iterator,
      i = "@@iterator";
  var f = "<<anonymous>>",
      e = {
    array: t("array"),
    bool: t("boolean"),
    func: t("function"),
    number: t("number"),
    object: t("object"),
    string: t("string"),
    symbol: t("symbol"),
    any: n(emptyFunctionThatReturnsNull),
    arrayOf: function arrayOf(c) {
      return n(function (e, t, n, r, o) {
        if ("function" != typeof c) return new y("Property `" + o + "` of component `" + n + "` has invalid PropType notation inside arrayOf.");
        var a = e[t];
        if (!Array.isArray(a)) return new y("Invalid " + r + " `" + o + "` of type `" + m(a) + "` supplied to `" + n + "`, expected an array.");

        for (var l = 0; l < a.length; l++) {
          var i = c(a, l, n, r, o + "[" + l + "]", ReactPropTypesSecret_1);
          if (i instanceof Error) return i;
        }

        return null;
      });
    },
    element: n(function (e, t, n, r, o) {
      var a = e[t];
      return l(a) ? null : new y("Invalid " + r + " `" + o + "` of type `" + m(a) + "` supplied to `" + n + "`, expected a single ReactElement.");
    }),
    elementType: n(function (e, t, n, r, o) {
      var a = e[t];
      return reactIs.isValidElementType(a) ? null : new y("Invalid " + r + " `" + o + "` of type `" + m(a) + "` supplied to `" + n + "`, expected a single ReactElement type.");
    }),
    instanceOf: function instanceOf(i) {
      return n(function (e, t, n, r, o) {
        if (e[t] instanceof i) return null;
        var a,
            l = i.name || f;
        return new y("Invalid " + r + " `" + o + "` of type `" + ((a = e[t]).constructor && a.constructor.name ? a.constructor.name : f) + "` supplied to `" + n + "`, expected instance of `" + l + "`.");
      });
    },
    node: n(function (e, t, n, r, o) {
      return c(e[t]) ? null : new y("Invalid " + r + " `" + o + "` supplied to `" + n + "`, expected a ReactNode.");
    }),
    objectOf: function objectOf(p) {
      return n(function (e, t, n, r, o) {
        if ("function" != typeof p) return new y("Property `" + o + "` of component `" + n + "` has invalid PropType notation inside objectOf.");
        var a = e[t],
            l = m(a);
        if ("object" !== l) return new y("Invalid " + r + " `" + o + "` of type `" + l + "` supplied to `" + n + "`, expected an object.");

        for (var i in a) {
          if (has$1(a, i)) {
            var c = p(a, i, n, r, o + "." + i, ReactPropTypesSecret_1);
            if (c instanceof Error) return c;
          }
        }

        return null;
      });
    },
    oneOf: function oneOf(c) {
      if (!Array.isArray(c)) return "production" !== process.env.NODE_ENV && printWarning$1(1 < arguments.length ? "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])." : "Invalid argument supplied to oneOf, expected an array."), emptyFunctionThatReturnsNull;
      return n(function (e, t, n, r, o) {
        for (var a = e[t], l = 0; l < c.length; l++) {
          if (p(a, c[l])) return null;
        }

        var i = JSON.stringify(c, function (e, t) {
          return "symbol" === s(t) ? String(t) : t;
        });
        return new y("Invalid " + r + " `" + o + "` of value `" + String(a) + "` supplied to `" + n + "`, expected one of " + i + ".");
      });
    },
    oneOfType: function oneOfType(l) {
      if (!Array.isArray(l)) return "production" !== process.env.NODE_ENV && printWarning$1("Invalid argument supplied to oneOfType, expected an instance of array."), emptyFunctionThatReturnsNull;

      for (var e = 0; e < l.length; e++) {
        var t = l[e];
        if ("function" != typeof t) return printWarning$1("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + r(t) + " at index " + e + "."), emptyFunctionThatReturnsNull;
      }

      return n(function (e, t, n, r, o) {
        for (var a = 0; a < l.length; a++) {
          if (null == (0, l[a])(e, t, n, r, o, ReactPropTypesSecret_1)) return null;
        }

        return new y("Invalid " + r + " `" + o + "` supplied to `" + n + "`.");
      });
    },
    shape: function shape(s) {
      return n(function (e, t, n, r, o) {
        var a = e[t],
            l = m(a);
        if ("object" !== l) return new y("Invalid " + r + " `" + o + "` of type `" + l + "` supplied to `" + n + "`, expected `object`.");

        for (var i in s) {
          var c = s[i];

          if (c) {
            var p = c(a, i, n, r, o + "." + i, ReactPropTypesSecret_1);
            if (p) return p;
          }
        }

        return null;
      });
    },
    exact: function exact(u) {
      return n(function (e, t, n, r, o) {
        var a = e[t],
            l = m(a);
        if ("object" !== l) return new y("Invalid " + r + " `" + o + "` of type `" + l + "` supplied to `" + n + "`, expected `object`.");
        var i = objectAssign({}, e[t], u);

        for (var c in i) {
          var p = u[c];
          if (!p) return new y("Invalid " + r + " `" + o + "` key `" + c + "` supplied to `" + n + "`.\nBad object: " + JSON.stringify(e[t], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(u), null, "  "));
          var s = p(a, c, n, r, o + "." + c, ReactPropTypesSecret_1);
          if (s) return s;
        }

        return null;
      });
    }
  };

  function p(e, t) {
    return e === t ? 0 !== e || 1 / e == 1 / t : e != e && t != t;
  }

  function y(e) {
    this.message = e, this.stack = "";
  }

  function n(p) {
    if ("production" !== process.env.NODE_ENV) var s = {},
        u = 0;

    function e(e, t, n, r, o, a, l) {
      if (r = r || f, a = a || n, l !== ReactPropTypesSecret_1) {
        if (d) {
          var i = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
          throw i.name = "Invariant Violation", i;
        }

        if ("production" !== process.env.NODE_ENV && "undefined" != typeof console) {
          var c = r + ":" + n;
          !s[c] && u < 3 && (printWarning$1("You are manually calling a React.PropTypes validation function for the `" + a + "` prop on `" + r + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), s[c] = !0, u++);
        }
      }

      return null == t[n] ? e ? null === t[n] ? new y("The " + o + " `" + a + "` is marked as required in `" + r + "`, but its value is `null`.") : new y("The " + o + " `" + a + "` is marked as required in `" + r + "`, but its value is `undefined`.") : null : p(t, n, r, o, a);
    }

    var t = e.bind(null, !1);
    return t.isRequired = e.bind(null, !0), t;
  }

  function t(i) {
    return n(function (e, t, n, r, o, a) {
      var l = e[t];
      return m(l) === i ? null : new y("Invalid " + r + " `" + o + "` of type `" + s(l) + "` supplied to `" + n + "`, expected `" + i + "`.");
    });
  }

  function c(e) {
    switch (typeof e) {
      case "number":
      case "string":
      case "undefined":
        return !0;

      case "boolean":
        return !e;

      case "object":
        if (Array.isArray(e)) return e.every(c);
        if (null === e || l(e)) return !0;

        var t = function (e) {
          var t = e && (a && e[a] || e[i]);
          if ("function" == typeof t) return t;
        }(e);

        if (!t) return !1;
        var n,
            r = t.call(e);

        if (t !== e.entries) {
          for (; !(n = r.next()).done;) {
            if (!c(n.value)) return !1;
          }
        } else for (; !(n = r.next()).done;) {
          var o = n.value;
          if (o && !c(o[1])) return !1;
        }

        return !0;

      default:
        return !1;
    }
  }

  function m(e) {
    var t,
        n = typeof e;
    return Array.isArray(e) ? "array" : e instanceof RegExp ? "object" : (t = e, "symbol" === n || t && ("Symbol" === t["@@toStringTag"] || "function" == typeof Symbol && t instanceof Symbol) ? "symbol" : n);
  }

  function s(e) {
    if (null == e) return "" + e;
    var t = m(e);

    if ("object" === t) {
      if (e instanceof Date) return "date";
      if (e instanceof RegExp) return "regexp";
    }

    return t;
  }

  function r(e) {
    var t = s(e);

    switch (t) {
      case "array":
      case "object":
        return "an " + t;

      case "boolean":
      case "date":
      case "regexp":
        return "a " + t;

      default:
        return t;
    }
  }

  return y.prototype = Error.prototype, e.checkPropTypes = checkPropTypes_1, e.resetWarningCache = checkPropTypes_1.resetWarningCache, e.PropTypes = e;
};

function emptyFunction() {}

function emptyFunctionWithReset() {}

emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function factoryWithThrowingShims() {
  function e(e, t, n, r, o, a) {
    if (a !== ReactPropTypesSecret_1) {
      var l = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
      throw l.name = "Invariant Violation", l;
    }
  }

  function t() {
    return e;
  }

  var n = {
    array: e.isRequired = e,
    bool: e,
    func: e,
    number: e,
    object: e,
    string: e,
    symbol: e,
    any: e,
    arrayOf: t,
    element: e,
    elementType: e,
    instanceOf: t,
    node: e,
    objectOf: t,
    oneOf: t,
    oneOfType: t,
    shape: t,
    exact: t,
    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };
  return n.PropTypes = n;
},
    propTypes = createCommonjsModule(function (e) {
  if ("production" !== process.env.NODE_ENV) {
    var t = reactIs;
    e.exports = factoryWithTypeCheckers(t.isElement, !0);
  } else e.exports = factoryWithThrowingShims();
}),
    DataTableStateContext = React.createContext(),
    useTableContext = function useTableContext() {
  return React.useContext(DataTableStateContext);
},
    DataTableProvider = function DataTableProvider(e) {
  var t = e.children,
      n = e.initialState;
  return React__default.createElement(DataTableStateContext.Provider, {
    value: n
  }, t);
};

DataTableProvider.propTypes = {
  initialState: propTypes.object.isRequired,
  children: propTypes.oneOfType([propTypes.arrayOf(propTypes.node), propTypes.node]).isRequired
};
var seed = 1;

function getNextValue() {
  return (seed = (9301 * seed + 49297) % 233280) / 233280;
}

function setSeed(e) {
  seed = e;
}

var alphabet,
    previousSeed,
    shuffled,
    randomFromSeed = {
  nextValue: getNextValue,
  seed: setSeed
},
    ORIGINAL = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ_-";

function reset() {
  shuffled = !1;
}

function setCharacters(e) {
  if (e) {
    if (e !== alphabet) {
      if (e.length !== ORIGINAL.length) throw new Error("Custom alphabet for shortid must be " + ORIGINAL.length + " unique characters. You submitted " + e.length + " characters: " + e);
      var t = e.split("").filter(function (e, t, n) {
        return t !== n.lastIndexOf(e);
      });
      if (t.length) throw new Error("Custom alphabet for shortid must be " + ORIGINAL.length + " unique characters. These characters were not unique: " + t.join(", "));
      alphabet = e, reset();
    }
  } else alphabet !== ORIGINAL && (alphabet = ORIGINAL, reset());
}

function characters(e) {
  return setCharacters(e), alphabet;
}

function setSeed$1(e) {
  randomFromSeed.seed(e), previousSeed !== e && (reset(), previousSeed = e);
}

function shuffle() {
  alphabet || setCharacters(ORIGINAL);

  for (var e, t = alphabet.split(""), n = [], r = randomFromSeed.nextValue(); 0 < t.length;) {
    r = randomFromSeed.nextValue(), e = Math.floor(r * t.length), n.push(t.splice(e, 1)[0]);
  }

  return n.join("");
}

function getShuffled() {
  return shuffled || (shuffled = shuffle());
}

function lookup(e) {
  return getShuffled()[e];
}

function get() {
  return alphabet || ORIGINAL;
}

var randomByte,
    alphabet_1 = {
  get: get,
  characters: characters,
  seed: setSeed$1,
  lookup: lookup,
  shuffled: getShuffled
},
    crypto = "object" == typeof window && (window.crypto || window.msCrypto),
    randomByteBrowser = randomByte = crypto && crypto.getRandomValues ? function (e) {
  return crypto.getRandomValues(new Uint8Array(e));
} : function (e) {
  for (var t = [], n = 0; n < e; n++) {
    t.push(Math.floor(256 * Math.random()));
  }

  return t;
},
    format_browser = function format_browser(e, t, n) {
  for (var r = (2 << Math.log(t.length - 1) / Math.LN2) - 1, o = -~(1.6 * r * n / t.length), a = "";;) {
    for (var l = e(o), i = o; i--;) {
      if ((a += t[l[i] & r] || "").length === +n) return a;
    }
  }
};

function generate(e) {
  for (var t, n = 0, r = ""; !t;) {
    r += format_browser(randomByteBrowser, alphabet_1.get(), 1), t = e < Math.pow(16, n + 1), n++;
  }

  return r;
}

var counter,
    previousSeconds,
    generate_1 = generate,
    REDUCE_TIME = 1567752802062,
    version = 7;

function build(e) {
  var t = "",
      n = Math.floor(.001 * (Date.now() - REDUCE_TIME));
  return n === previousSeconds ? counter++ : (counter = 0, previousSeconds = n), t += generate_1(version), t += generate_1(e), 0 < counter && (t += generate_1(counter)), t += generate_1(n);
}

var build_1 = build;

function isShortId(e) {
  return !(!e || "string" != typeof e || e.length < 6) && !new RegExp("[^" + alphabet_1.get().replace(/[|\\{}()[\]^$+*?.-]/g, "\\$&") + "]").test(e);
}

var isValid = isShortId,
    lib = createCommonjsModule(function (t) {
  var n = 0;

  function e() {
    return build_1(n);
  }

  t.exports = e, t.exports.generate = e, t.exports.seed = function (e) {
    return alphabet_1.seed(e), t.exports;
  }, t.exports.worker = function (e) {
    return n = e, t.exports;
  }, t.exports.characters = function (e) {
    return void 0 !== e && alphabet_1.characters(e), alphabet_1.shuffled();
  }, t.exports.isValid = isValid;
}),
    lib_1 = lib.generate,
    lib_2 = lib.seed,
    lib_3 = lib.worker,
    lib_4 = lib.characters,
    lib_5 = lib.isValid,
    shortid = lib,
    lodash_orderby = createCommonjsModule(function (e, t) {
  var n = "Expected a function",
      r = "__lodash_hash_undefined__",
      _ = 1,
      v = 2,
      a = 1 / 0,
      o = 9007199254740991,
      g = "[object Arguments]",
      h = "[object Array]",
      T = "[object Boolean]",
      w = "[object Date]",
      R = "[object Error]",
      l = "[object Function]",
      i = "[object GeneratorFunction]",
      x = "[object Map]",
      O = "[object Number]",
      S = "[object Object]",
      c = "[object Promise]",
      j = "[object RegExp]",
      C = "[object Set]",
      E = "[object String]",
      P = "[object Symbol]",
      p = "[object WeakMap]",
      I = "[object ArrayBuffer]",
      $ = "[object DataView]",
      s = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      u = /^\w*$/,
      d = /^\./,
      f = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
      y = /\\(\\)?/g,
      m = /^\[object .+?Constructor\]$/,
      b = /^(?:0|[1-9]\d*)$/,
      k = {};
  k["[object Float32Array]"] = k["[object Float64Array]"] = k["[object Int8Array]"] = k["[object Int16Array]"] = k["[object Int32Array]"] = k["[object Uint8Array]"] = k["[object Uint8ClampedArray]"] = k["[object Uint16Array]"] = k["[object Uint32Array]"] = !0, k[g] = k[h] = k[I] = k[T] = k[$] = k[w] = k[R] = k[l] = k[x] = k[O] = k[S] = k[j] = k[C] = k[E] = k[p] = !1;

  var A = "object" == typeof commonjsGlobal && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal,
      L = "object" == typeof self && self && self.Object === Object && self,
      F = A || L || Function("return this")(),
      M = t && !t.nodeType && t,
      H = M && e && !e.nodeType && e,
      N = H && H.exports === M && A.process,
      D = function () {
    try {
      return N && N.binding("util");
    } catch (e) {}
  }(),
      W = D && D.isTypedArray;

  function z(e, t) {
    for (var n = -1, r = e ? e.length : 0, o = Array(r); ++n < r;) {
      o[n] = t(e[n], n, e);
    }

    return o;
  }

  function q(e, t) {
    for (var n = -1, r = e ? e.length : 0; ++n < r;) {
      if (t(e[n], n, e)) return 1;
    }
  }

  function B(t) {
    return function (e) {
      return t(e);
    };
  }

  function U(e) {
    var t = !1;
    if (null != e && "function" != typeof e.toString) try {
      t = !!(e + "");
    } catch (e) {}
    return t;
  }

  function V(e) {
    var n = -1,
        r = Array(e.size);
    return e.forEach(function (e, t) {
      r[++n] = [t, e];
    }), r;
  }

  function G(e) {
    var t = -1,
        n = Array(e.size);
    return e.forEach(function (e) {
      n[++t] = e;
    }), n;
  }

  var Y,
      K,
      J,
      Q = Array.prototype,
      X = Function.prototype,
      Z = Object.prototype,
      ee = F["__core-js_shared__"],
      te = (Y = /[^.]+$/.exec(ee && ee.keys && ee.keys.IE_PROTO || "")) ? "Symbol(src)_1." + Y : "",
      ne = X.toString,
      re = Z.hasOwnProperty,
      oe = Z.toString,
      ae = RegExp("^" + ne.call(re).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"),
      le = F.Symbol,
      ie = F.Uint8Array,
      ce = Z.propertyIsEnumerable,
      pe = Q.splice,
      se = (K = Object.keys, J = Object, function (e) {
    return K(J(e));
  }),
      ue = Ye(F, "DataView"),
      de = Ye(F, "Map"),
      fe = Ye(F, "Promise"),
      ye = Ye(F, "Set"),
      me = Ye(F, "WeakMap"),
      be = Ye(Object, "create"),
      _e = nt(ue),
      ge = nt(de),
      he = nt(fe),
      ve = nt(ye),
      Te = nt(me),
      we = le ? le.prototype : void 0,
      Re = we ? we.valueOf : void 0,
      xe = we ? we.toString : void 0;

  function Oe(e) {
    var t = -1,
        n = e ? e.length : 0;

    for (this.clear(); ++t < n;) {
      var r = e[t];
      this.set(r[0], r[1]);
    }
  }

  function Se(e) {
    var t = -1,
        n = e ? e.length : 0;

    for (this.clear(); ++t < n;) {
      var r = e[t];
      this.set(r[0], r[1]);
    }
  }

  function je(e) {
    var t = -1,
        n = e ? e.length : 0;

    for (this.clear(); ++t < n;) {
      var r = e[t];
      this.set(r[0], r[1]);
    }
  }

  function Ce(e) {
    var t = -1,
        n = e ? e.length : 0;

    for (this.__data__ = new je(); ++t < n;) {
      this.add(e[t]);
    }
  }

  function Ee(e) {
    this.__data__ = new Se(e);
  }

  function Pe(e, t) {
    var n = lt(e) || at(e) ? function (e, t) {
      for (var n = -1, r = Array(e); ++n < e;) {
        r[n] = t(n);
      }

      return r;
    }(e.length, String) : [],
        r = n.length,
        o = !!r;

    for (var a in e) {
      !t && !re.call(e, a) || o && ("length" == a || Je(a, r)) || n.push(a);
    }

    return n;
  }

  function Ie(e, t) {
    for (var n = e.length; n--;) {
      if (ot(e[n][0], t)) return n;
    }

    return -1;
  }

  Oe.prototype.clear = function () {
    this.__data__ = be ? be(null) : {};
  }, Oe.prototype.delete = function (e) {
    return this.has(e) && delete this.__data__[e];
  }, Oe.prototype.get = function (e) {
    var t = this.__data__;

    if (be) {
      var n = t[e];
      return n === r ? void 0 : n;
    }

    return re.call(t, e) ? t[e] : void 0;
  }, Oe.prototype.has = function (e) {
    var t = this.__data__;
    return be ? void 0 !== t[e] : re.call(t, e);
  }, Oe.prototype.set = function (e, t) {
    return this.__data__[e] = be && void 0 === t ? r : t, this;
  }, Se.prototype.clear = function () {
    this.__data__ = [];
  }, Se.prototype.delete = function (e) {
    var t = this.__data__,
        n = Ie(t, e);
    return !(n < 0) && (n == t.length - 1 ? t.pop() : pe.call(t, n, 1), !0);
  }, Se.prototype.get = function (e) {
    var t = this.__data__,
        n = Ie(t, e);
    return n < 0 ? void 0 : t[n][1];
  }, Se.prototype.has = function (e) {
    return -1 < Ie(this.__data__, e);
  }, Se.prototype.set = function (e, t) {
    var n = this.__data__,
        r = Ie(n, e);
    return r < 0 ? n.push([e, t]) : n[r][1] = t, this;
  }, je.prototype.clear = function () {
    this.__data__ = {
      hash: new Oe(),
      map: new (de || Se)(),
      string: new Oe()
    };
  }, je.prototype.delete = function (e) {
    return Ge(this, e).delete(e);
  }, je.prototype.get = function (e) {
    return Ge(this, e).get(e);
  }, je.prototype.has = function (e) {
    return Ge(this, e).has(e);
  }, je.prototype.set = function (e, t) {
    return Ge(this, e).set(e, t), this;
  }, Ce.prototype.add = Ce.prototype.push = function (e) {
    return this.__data__.set(e, r), this;
  }, Ce.prototype.has = function (e) {
    return this.__data__.has(e);
  }, Ee.prototype.clear = function () {
    this.__data__ = new Se();
  }, Ee.prototype.delete = function (e) {
    return this.__data__.delete(e);
  }, Ee.prototype.get = function (e) {
    return this.__data__.get(e);
  }, Ee.prototype.has = function (e) {
    return this.__data__.has(e);
  }, Ee.prototype.set = function (e, t) {
    var n = this.__data__;

    if (n instanceof Se) {
      var r = n.__data__;
      if (!de || r.length < 199) return r.push([e, t]), this;
      n = this.__data__ = new je(r);
    }

    return n.set(e, t), this;
  };

  var $e,
      ke,
      Ae,
      Le = ($e = function $e(e, t) {
    return e && Fe(e, t, yt);
  }, function (e, t) {
    if (null == e) return e;
    if (!it(e)) return $e(e, t);

    for (var n = e.length, r = ke ? n : -1, o = Object(e); (ke ? r-- : ++r < n) && !1 !== t(o[r], r, o);) {
      ;
    }

    return e;
  }),
      Fe = function Fe(e, t, n) {
    for (var r = -1, o = Object(e), a = n(e), l = a.length; l--;) {
      var i = a[Ae ? l : ++r];
      if (!1 === t(o[i], i, o)) break;
    }

    return e;
  };

  function Me(e, t) {
    for (var n = 0, r = (t = Qe(t, e) ? [t] : Be(t)).length; null != e && n < r;) {
      e = e[tt(t[n++])];
    }

    return n && n == r ? e : void 0;
  }

  function He(e, t) {
    return null != e && t in Object(e);
  }

  function Ne(e, t, n, r, o) {
    return e === t || (null == e || null == t || !st(e) && !ut(t) ? e != e && t != t : function (e, t, n, r, o, a) {
      var l = lt(e),
          i = lt(t),
          c = h,
          p = h;
      l || (c = (c = Ke(e)) == g ? S : c);
      i || (p = (p = Ke(t)) == g ? S : p);
      var s = c == S && !U(e),
          u = p == S && !U(t),
          d = c == p;
      if (d && !s) return a = a || new Ee(), l || ft(e) ? Ve(e, t, n, r, o, a) : function (e, t, n, r, o, a, l) {
        switch (n) {
          case $:
            if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
            e = e.buffer, t = t.buffer;

          case I:
            return e.byteLength == t.byteLength && r(new ie(e), new ie(t)) ? !0 : !1;

          case T:
          case w:
          case O:
            return ot(+e, +t);

          case R:
            return e.name == t.name && e.message == t.message;

          case j:
          case E:
            return e == t + "";

          case x:
            var i = V;

          case C:
            var c = a & v;
            if (i = i || G, e.size != t.size && !c) return !1;
            var p = l.get(e);
            if (p) return p == t;
            a |= _, l.set(e, t);
            var s = Ve(i(e), i(t), r, o, a, l);
            return l.delete(e), s;

          case P:
            if (Re) return Re.call(e) == Re.call(t);
        }

        return !1;
      }(e, t, c, n, r, o, a);

      if (!(o & v)) {
        var f = s && re.call(e, "__wrapped__"),
            y = u && re.call(t, "__wrapped__");

        if (f || y) {
          var m = f ? e.value() : e,
              b = y ? t.value() : t;
          return a = a || new Ee(), n(m, b, r, o, a);
        }
      }

      return d && (a = a || new Ee(), function (e, t, n, r, o, a) {
        var l = o & v,
            i = yt(e),
            c = i.length,
            p = yt(t).length;
        if (c != p && !l) return !1;
        var s = c;

        for (; s--;) {
          var u = i[s];
          if (!(l ? u in t : re.call(t, u))) return !1;
        }

        var d = a.get(e);
        if (d && a.get(t)) return d == t;
        var f = !0;
        a.set(e, t), a.set(t, e);
        var y = l;

        for (; ++s < c;) {
          u = i[s];
          var m = e[u],
              b = t[u];
          if (r) var _ = l ? r(b, m, u, t, e, a) : r(m, b, u, e, t, a);

          if (!(void 0 === _ ? m === b || n(m, b, r, o, a) : _)) {
            f = !1;
            break;
          }

          y = y || "constructor" == u;
        }

        if (f && !y) {
          var g = e.constructor,
              h = t.constructor;
          g != h && "constructor" in e && "constructor" in t && !("function" == typeof g && g instanceof g && "function" == typeof h && h instanceof h) && (f = !1);
        }

        return a.delete(e), a.delete(t), f;
      }(e, t, n, r, o, a));
    }(e, t, Ne, n, r, o));
  }

  function De(e) {
    var t;
    return st(e) && (t = e, !(te && te in t)) && (ct(e) || U(e) ? ae : m).test(nt(e));
  }

  function We(e) {
    return "function" == typeof e ? e : null == e ? mt : "object" == typeof e ? lt(e) ? function (c, p) {
      if (Qe(c) && Xe(p)) return Ze(tt(c), p);
      return function (e) {
        var t,
            n,
            r,
            o,
            a,
            l,
            i = (n = c, void 0 === (o = null == (t = e) ? void 0 : Me(t, n)) ? r : o);
        return void 0 === i && i === p ? (l = c, null != (a = e) && function (e, t, n) {
          t = Qe(t, e) ? [t] : Be(t);

          for (var r, o = -1, a = t.length; ++o < a;) {
            var l = tt(t[o]);
            if (!(r = null != e && n(e, l))) break;
            e = e[l];
          }

          return r || !!(a = e ? e.length : 0) && pt(a) && Je(l, a) && (lt(e) || at(e));
        }(a, l, He)) : Ne(p, i, void 0, _ | v);
      };
    }(e[0], e[1]) : function (t) {
      var n = function (e) {
        var t = yt(e),
            n = t.length;

        for (; n--;) {
          var r = t[n],
              o = e[r];
          t[n] = [r, o, Xe(o)];
        }

        return t;
      }(t);

      if (1 == n.length && n[0][2]) return Ze(n[0][0], n[0][1]);
      return function (e) {
        return e === t || function (e, t, n, r) {
          var o = n.length,
              a = o,
              l = !r;
          if (null == e) return !a;

          for (e = Object(e); o--;) {
            var i = n[o];
            if (l && i[2] ? i[1] !== e[i[0]] : !(i[0] in e)) return !1;
          }

          for (; ++o < a;) {
            var c = (i = n[o])[0],
                p = e[c],
                s = i[1];

            if (l && i[2]) {
              if (void 0 === p && !(c in e)) return !1;
            } else {
              var u = new Ee();
              if (r) var d = r(p, s, c, e, t, u);
              if (!(void 0 === d ? Ne(s, p, r, _ | v, u) : d)) return !1;
            }
          }

          return !0;
        }(e, t, n);
      };
    }(e) : Qe(t = e) ? function (t) {
      return function (e) {
        return null == e ? void 0 : e[t];
      };
    }(tt(t)) : function (t) {
      return function (e) {
        return Me(e, t);
      };
    }(t);
    var t;
  }

  function ze(e) {
    if (n = (t = e) && t.constructor, r = "function" == typeof n && n.prototype || Z, t !== r) return se(e);
    var t,
        n,
        r,
        o = [];

    for (var a in Object(e)) {
      re.call(e, a) && "constructor" != a && o.push(a);
    }

    return o;
  }

  function qe(e, r, n) {
    var t,
        o,
        a,
        l,
        i = -1;
    return r = z(r.length ? r : [mt], B(We)), function (e, t) {
      var n = e.length;

      for (e.sort(t); n--;) {
        e[n] = e[n].value;
      }

      return e;
    }((o = function o(t, e, n) {
      return {
        criteria: z(r, function (e) {
          return e(t);
        }),
        index: ++i,
        value: t
      };
    }, a = -1, l = it(t = e) ? Array(t.length) : [], Le(t, function (e, t, n) {
      l[++a] = o(e, t, n);
    }), l), function (e, t) {
      return function (e, t, n) {
        var r = -1,
            o = e.criteria,
            a = t.criteria,
            l = o.length,
            i = n.length;

        for (; ++r < l;) {
          var c = Ue(o[r], a[r]);

          if (c) {
            if (i <= r) return c;
            var p = n[r];
            return c * ("desc" == p ? -1 : 1);
          }
        }

        return e.index - t.index;
      }(e, t, n);
    });
  }

  function Be(e) {
    return lt(e) ? e : et(e);
  }

  function Ue(e, t) {
    if (e !== t) {
      var n = void 0 !== e,
          r = null === e,
          o = e == e,
          a = dt(e),
          l = void 0 !== t,
          i = null === t,
          c = t == t,
          p = dt(t);
      if (!i && !p && !a && t < e || a && l && c && !i && !p || r && l && c || !n && c || !o) return 1;
      if (!r && !a && !p && e < t || p && n && o && !r && !a || i && n && o || !l && o || !c) return -1;
    }

    return 0;
  }

  function Ve(e, t, n, r, o, a) {
    var l = o & v,
        i = e.length,
        c = t.length;
    if (i != c && !(l && i < c)) return !1;
    var p = a.get(e);
    if (p && a.get(t)) return p == t;
    var s = -1,
        u = !0,
        d = o & _ ? new Ce() : void 0;

    for (a.set(e, t), a.set(t, e); ++s < i;) {
      var f = e[s],
          y = t[s];
      if (r) var m = l ? r(y, f, s, t, e, a) : r(f, y, s, e, t, a);

      if (void 0 !== m) {
        if (m) continue;
        u = !1;
        break;
      }

      if (d) {
        if (!q(t, function (e, t) {
          return !d.has(t) && (f === e || n(f, e, r, o, a)) && d.add(t);
        })) {
          u = !1;
          break;
        }
      } else if (f !== y && !n(f, y, r, o, a)) {
        u = !1;
        break;
      }
    }

    return a.delete(e), a.delete(t), u;
  }

  function Ge(e, t) {
    var n,
        r,
        o = e.__data__;
    return ("string" == (r = typeof (n = t)) || "number" == r || "symbol" == r || "boolean" == r ? "__proto__" !== n : null === n) ? o["string" == typeof t ? "string" : "hash"] : o.map;
  }

  function Ye(e, t) {
    var n,
        r,
        o = (r = t, null == (n = e) ? void 0 : n[r]);
    return De(o) ? o : void 0;
  }

  var Ke = function Ke(e) {
    return oe.call(e);
  };

  function Je(e, t) {
    return !!(t = null == t ? o : t) && ("number" == typeof e || b.test(e)) && -1 < e && e % 1 == 0 && e < t;
  }

  function Qe(e, t) {
    if (!lt(e)) {
      var n = typeof e;
      return "number" == n || "symbol" == n || "boolean" == n || null == e || dt(e) || u.test(e) || !s.test(e) || null != t && e in Object(t);
    }
  }

  function Xe(e) {
    return e == e && !st(e);
  }

  function Ze(t, n) {
    return function (e) {
      return null != e && e[t] === n && (void 0 !== n || t in Object(e));
    };
  }

  (ue && Ke(new ue(new ArrayBuffer(1))) != $ || de && Ke(new de()) != x || fe && Ke(fe.resolve()) != c || ye && Ke(new ye()) != C || me && Ke(new me()) != p) && (Ke = function Ke(e) {
    var t = oe.call(e),
        n = t == S ? e.constructor : void 0,
        r = n ? nt(n) : void 0;
    if (r) switch (r) {
      case _e:
        return $;

      case ge:
        return x;

      case he:
        return c;

      case ve:
        return C;

      case Te:
        return p;
    }
    return t;
  });
  var et = rt(function (e) {
    var t;
    e = null == (t = e) ? "" : function (e) {
      if ("string" == typeof e) return e;
      if (dt(e)) return xe ? xe.call(e) : "";
      var t = e + "";
      return "0" == t && 1 / e == -a ? "-0" : t;
    }(t);
    var o = [];
    return d.test(e) && o.push(""), e.replace(f, function (e, t, n, r) {
      o.push(n ? r.replace(y, "$1") : t || e);
    }), o;
  });

  function tt(e) {
    if ("string" == typeof e || dt(e)) return e;
    var t = e + "";
    return "0" == t && 1 / e == -a ? "-0" : t;
  }

  function nt(e) {
    if (null != e) {
      try {
        return ne.call(e);
      } catch (e) {}

      try {
        return e + "";
      } catch (e) {}
    }

    return "";
  }

  function rt(o, a) {
    if ("function" != typeof o || a && "function" != typeof a) throw new TypeError(n);

    var l = function l() {
      var e = arguments,
          t = a ? a.apply(this, e) : e[0],
          n = l.cache;
      if (n.has(t)) return n.get(t);
      var r = o.apply(this, e);
      return l.cache = n.set(t, r), r;
    };

    return l.cache = new (rt.Cache || je)(), l;
  }

  function ot(e, t) {
    return e === t || e != e && t != t;
  }

  function at(e) {
    return ut(t = e) && it(t) && re.call(e, "callee") && (!ce.call(e, "callee") || oe.call(e) == g);
    var t;
  }

  rt.Cache = je;
  var lt = Array.isArray;

  function it(e) {
    return null != e && pt(e.length) && !ct(e);
  }

  function ct(e) {
    var t = st(e) ? oe.call(e) : "";
    return t == l || t == i;
  }

  function pt(e) {
    return "number" == typeof e && -1 < e && e % 1 == 0 && e <= o;
  }

  function st(e) {
    var t = typeof e;
    return e && ("object" == t || "function" == t);
  }

  function ut(e) {
    return !!e && "object" == typeof e;
  }

  function dt(e) {
    return "symbol" == typeof e || ut(e) && oe.call(e) == P;
  }

  var ft = W ? B(W) : function (e) {
    return ut(e) && pt(e.length) && !!k[oe.call(e)];
  };

  function yt(e) {
    return (it(e) ? Pe : ze)(e);
  }

  function mt(e) {
    return e;
  }

  e.exports = function (e, t, n, r) {
    return null == e ? [] : (lt(t) || (t = null == t ? [] : [t]), lt(n = r ? void 0 : n) || (n = null == n ? [] : [n]), qe(e, t, n));
  };
}),
    isEmpty = function isEmpty(e) {
  var t = 0 < arguments.length && void 0 !== e ? e : "";
  return null == t || 0 === t.length;
},
    sort = function sort(e, t, n, r) {
  var o = 1 < arguments.length && void 0 !== t ? t : "",
      a = 2 < arguments.length ? n : void 0,
      l = 3 < arguments.length ? r : void 0;
  return (l && "function" == typeof l ? l : lodash_orderby)(e, o, a);
},
    getProperty = function getProperty(e, t, n) {
  if (!t) return null;
  if ("string" != typeof t && "function" != typeof t) throw new Error("selector must be a . delimited string eg (my.property) or function (e.g. row => row.field");
  return n && "function" == typeof n ? n(e) : t && "function" == typeof t ? t(e) : t.split(".").reduce(function (e, t) {
    var n = t.match(/[^\]\\[.]+/g);

    if (1 < n.length) {
      var r = 0;
      if (r < n.length) return e[n[r]][n[r + 1]];
    }

    return e[t];
  }, e);
},
    insertItem = function insertItem(e, t, n) {
  var r = 0 < arguments.length && void 0 !== e ? e : [],
      o = 1 < arguments.length && void 0 !== t ? t : {},
      a = 2 < arguments.length && void 0 !== n ? n : 0;
  return [].concat(_toConsumableArray(r.slice(0, a)), [o], _toConsumableArray(r.slice(a)));
},
    removeItem = function removeItem(e, t, n) {
  var r = 1 < arguments.length && void 0 !== t ? t : {},
      o = 2 < arguments.length ? n : void 0,
      a = (0 < arguments.length && void 0 !== e ? e : []).slice();
  return r[o] ? a.splice(a.findIndex(function (e) {
    return e[o] === r[o];
  }), 1) : a.splice(a.findIndex(function (e) {
    return e === r;
  }), 1), a;
},
    decorateColumns = function decorateColumns(e) {
  return e.map(function (e) {
    return _objectSpread2(_objectSpread2({
      id: shortid.generate()
    }, e), {}, {
      sortable: e.sortable || !!e.sortFunction || void 0
    });
  });
},
    getSortDirection = function getSortDirection(e) {
  return e ? "asc" : "desc";
},
    handleFunctionProps = function handleFunctionProps(r) {
  for (var e = arguments.length, o = new Array(1 < e ? e - 1 : 0), t = 1; t < e; t++) {
    o[t - 1] = arguments[t];
  }

  var a;
  return Object.keys(r).map(function (e) {
    return r[e];
  }).forEach(function (e, t) {
    var n = r;
    "function" == typeof e && (a = _objectSpread2(_objectSpread2({}, n), {}, _defineProperty({}, Object.keys(r)[t], e.apply(void 0, o))), delete n[e]);
  }), a || r;
},
    getNumberOfPages = function getNumberOfPages(e, t) {
  return Math.ceil(e / t);
},
    recalculatePage = function recalculatePage(e, t) {
  return Math.min(e, t);
},
    noop = function noop() {
  return null;
},
    getConditionalStyle = function getConditionalStyle(e, t) {
  var n = 0 < arguments.length && void 0 !== e ? e : {},
      r = 1 < arguments.length && void 0 !== t ? t : [],
      o = {};
  return r.length && r.forEach(function (e) {
    if (!e.when || "function" != typeof e.when) throw new Error('"when" must be defined in the conditional style object and must be function');
    e.when(n) && (o = e.style || {});
  }), o;
},
    isRowSelected = function isRowSelected(e, t, n) {
  var r = 0 < arguments.length && void 0 !== e ? e : {},
      o = 1 < arguments.length && void 0 !== t ? t : [],
      a = 2 < arguments.length && void 0 !== n ? n : "id";
  return r[a] ? o.some(function (e) {
    return e[a] === r[a];
  }) : o.some(function (e) {
    return e === r;
  });
},
    detectRTL = function detectRTL(e) {
  var t = 0 < arguments.length && void 0 !== e ? e : "auto";
  return "auto" !== t ? "rtl" === t : !("undefined" == typeof window || !window.document || !window.document.createElement) && ("rtl" === document.getElementsByTagName("BODY")[0] || "rtl" === document.getElementsByTagName("HTML")[0].dir);
};

function tableReducer(t, e) {
  switch (e.type) {
    case "SELECT_ALL_ROWS":
      var n = e.rows,
          r = e.rowCount,
          o = e.mergeSelections,
          a = e.keyField,
          l = !t.allSelected;

      if (o) {
        var i = l ? [].concat(_toConsumableArray(t.selectedRows), _toConsumableArray(n.filter(function (e) {
          return !isRowSelected(e, t.selectedRows, a);
        }))) : t.selectedRows.filter(function (e) {
          return !isRowSelected(e, n, a);
        });
        return _objectSpread2(_objectSpread2({}, t), {}, {
          allSelected: l,
          selectedCount: i.length,
          selectedRows: i
        });
      }

      return _objectSpread2(_objectSpread2({}, t), {}, {
        allSelected: l,
        selectedCount: l ? r : 0,
        selectedRows: l ? n : []
      });

    case "SELECT_SINGLE_ROW":
      var c = e.row,
          p = e.isSelected,
          s = e.keyField,
          u = e.rowCount;
      return p ? _objectSpread2(_objectSpread2({}, t), {}, {
        selectedCount: 0 < t.selectedRows.length ? t.selectedRows.length - 1 : 0,
        allSelected: !1,
        selectedRows: removeItem(t.selectedRows, c, s)
      }) : _objectSpread2(_objectSpread2({}, t), {}, {
        selectedCount: t.selectedRows.length + 1,
        allSelected: t.selectedRows.length + 1 === u,
        selectedRows: insertItem(t.selectedRows, c)
      });

    case "SELECT_MULTIPLE_ROWS":
      var d = e.selectedRows,
          f = e.rows,
          y = e.mergeSelections,
          m = e.keyField;

      if (y) {
        var b = [].concat(_toConsumableArray(t.selectedRows), _toConsumableArray(d.filter(function (e) {
          return !isRowSelected(e, t.selectedRows, m);
        })));
        return _objectSpread2(_objectSpread2({}, t), {}, {
          selectedCount: b.length,
          allSelected: !1,
          selectedRows: b
        });
      }

      return _objectSpread2(_objectSpread2({}, t), {}, {
        selectedCount: d.length,
        allSelected: d.length === f.length,
        selectedRows: d
      });

    case "SORT_CHANGE":
      var _ = e.sortColumn,
          g = e.sortDirection,
          h = e.sortServer,
          v = e.selectedColumn,
          T = e.pagination,
          w = e.paginationServer,
          R = e.visibleOnly,
          x = e.persistSelectedOnSort,
          O = T && w && !x || h || R;
      return _objectSpread2(_objectSpread2({}, t), {}, {
        sortColumn: _,
        selectedColumn: v,
        sortDirection: g,
        currentPage: 1
      }, O && {
        allSelected: !1,
        selectedCount: 0,
        selectedRows: []
      });

    case "CHANGE_PAGE":
      var S = e.page,
          j = e.paginationServer,
          C = e.visibleOnly,
          E = e.persistSelectedOnPageChange,
          P = j && E,
          I = j && !E || C;
      return _objectSpread2(_objectSpread2(_objectSpread2({}, t), {}, {
        currentPage: S
      }, P && {
        allSelected: !1
      }), I && {
        allSelected: !1,
        selectedCount: 0,
        selectedRows: []
      });

    case "CHANGE_ROWS_PER_PAGE":
      var $ = e.rowsPerPage,
          k = e.page;
      return _objectSpread2(_objectSpread2({}, t), {}, {
        currentPage: k,
        rowsPerPage: $
      });

    case "CLEAR_SELECTED_ROWS":
      var A = e.selectedRowsFlag;
      return _objectSpread2(_objectSpread2({}, t), {}, {
        allSelected: !1,
        selectedCount: 0,
        selectedRows: [],
        selectedRowsFlag: A
      });

    default:
      throw new Error("Unhandled action type: ".concat(e.type));
  }
}

function _templateObject2() {
  var e = _taggedTemplateLiteral(["\n  position: relative;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  max-width: 100%;\n  ", ";\n  ", ";\n"]);

  return _templateObject2 = function _templateObject2() {
    return e;
  }, e;
}

function _templateObject() {
  var e = _taggedTemplateLiteral(["\n  pointer-events: none;\n  opacity: 0.4;\n"]);

  return _templateObject = function _templateObject() {
    return e;
  }, e;
}

var disabled = styled.css(_templateObject()),
    TableStyle = styled__default.div(_templateObject2(), function (e) {
  return e.disabled && disabled;
}, function (e) {
  return e.theme.table.style;
});

function _templateObject$1() {
  var e = _taggedTemplateLiteral(["\n  display: flex;\n  text-align: left;\n  ", ";\n"]);

  return _templateObject$1 = function _templateObject$1() {
    return e;
  }, e;
}

var TableHead = styled__default.div(_templateObject$1(), function (e) {
  return e.theme.head.style;
});

function _templateObject2$1() {
  var e = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: stretch;\n  width: 100%;\n  ", ";\n  ", ";\n  ", ";\n"]);

  return _templateObject2$1 = function _templateObject2$1() {
    return e;
  }, e;
}

function _templateObject$2() {
  var e = _taggedTemplateLiteral(["\n  pointer-events: none;\n"]);

  return _templateObject$2 = function _templateObject$2() {
    return e;
  }, e;
}

var disabled$1 = styled.css(_templateObject$2()),
    TableHeadRow = styled__default.div(_templateObject2$1(), function (e) {
  return e.theme.headRow.style;
}, function (e) {
  return e.dense && e.theme.headRow.denseStyle;
}, function (e) {
  return e.disabled && disabled$1;
});

function _templateObject4() {
  var e = _taggedTemplateLiteral(["\n    @media screen and (max-width: ", "px) {\n      ", "\n    }\n  "]);

  return _templateObject4 = function _templateObject4() {
    return e;
  }, e;
}

function _templateObject3() {
  var e = _taggedTemplateLiteral(["\n    @media screen and (max-width: ", "px) {\n      ", "\n    }\n  "]);

  return _templateObject3 = function _templateObject3() {
    return e;
  }, e;
}

function _templateObject2$2() {
  var e = _taggedTemplateLiteral(["\n    @media screen and (max-width: ", "px) {\n      ", "\n    }\n  "]);

  return _templateObject2$2 = function _templateObject2$2() {
    return e;
  }, e;
}

function _templateObject$3() {
  var e = _taggedTemplateLiteral(["\n    @media screen and (max-width: ", "px) {\n      ", "\n    }\n  "]);

  return _templateObject$3 = function _templateObject$3() {
    return e;
  }, e;
}

var SMALL = 599,
    MEDIUM = 959,
    LARGE = 1280,
    media = {
  sm: function sm() {
    return styled.css(_templateObject$3(), SMALL, styled.css.apply(void 0, arguments));
  },
  md: function md() {
    return styled.css(_templateObject2$2(), MEDIUM, styled.css.apply(void 0, arguments));
  },
  lg: function lg() {
    return styled.css(_templateObject3(), LARGE, styled.css.apply(void 0, arguments));
  },
  custom: function custom(e) {
    return function () {
      return styled.css(_templateObject4(), e, styled.css.apply(void 0, arguments));
    };
  }
};

function _templateObject7() {
  var e = _taggedTemplateLiteral(["\n    display: none;\n  "]);

  return _templateObject7 = function _templateObject7() {
    return e;
  }, e;
}

function _templateObject6() {
  var e = _taggedTemplateLiteral(["\n    display: none;\n  "]);

  return _templateObject6 = function _templateObject6() {
    return e;
  }, e;
}

function _templateObject5() {
  var e = _taggedTemplateLiteral(["\n    display: none;\n  "]);

  return _templateObject5 = function _templateObject5() {
    return e;
  }, e;
}

function _templateObject4$1() {
  var e = _taggedTemplateLiteral(["\n    display: none;\n  "]);

  return _templateObject4$1 = function _templateObject4$1() {
    return e;
  }, e;
}

function _templateObject3$1() {
  var e = _taggedTemplateLiteral(["\n    min-width: ", ";\n    max-width: ", ";\n  "]);

  return _templateObject3$1 = function _templateObject3$1() {
    return e;
  }, e;
}

function _templateObject2$3() {
  var e = _taggedTemplateLiteral(["\n  flex-grow: ", ";\n  flex-shrink: 0;\n  flex-basis: 0;\n  max-width: ", ";\n  min-width: ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  /* handle hiding cells */\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"]);

  return _templateObject2$3 = function _templateObject2$3() {
    return e;
  }, e;
}

function _templateObject$4() {
  var e = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  box-sizing: border-box;\n  line-height: normal;\n  ", ";\n  ", ";\n"]);

  return _templateObject$4 = function _templateObject$4() {
    return e;
  }, e;
}

var CellBase = styled__default.div(_templateObject$4(), function (e) {
  return e.theme[e.head ? "headCells" : "cells"].style;
}, function (e) {
  return e.noPadding && "padding: 0";
}),
    Cell = styled__default(CellBase)(_templateObject2$3(), function (e) {
  return 0 === e.column.grow || e.column.button ? 0 : e.column.grow || 1;
}, function (e) {
  return e.column.maxWidth || "100%";
}, function (e) {
  return e.column.minWidth || "100px";
}, function (e) {
  return e.column.width && styled.css(_templateObject3$1(), e.column.width, e.column.width);
}, function (e) {
  return e.column.right && "justify-content: flex-end";
}, function (e) {
  return (e.column.center || e.column.button) && "justify-content: center";
}, function (e) {
  return (e.column.compact || e.column.button) && "padding: 0";
}, function (e) {
  return e.column.hide && "sm" === e.column.hide && media.sm(_templateObject4$1());
}, function (e) {
  return e.column.hide && "md" === e.column.hide && media.md(_templateObject5());
}, function (e) {
  return e.column.hide && "lg" === e.column.hide && media.lg(_templateObject6());
}, function (e) {
  return e.column.hide && Number.isInteger(e.column.hide) && media.custom(e.column.hide)(_templateObject7());
});

function _templateObject$5() {
  var e = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: 400;\n\n  div:first-child {\n    white-space: ", ";\n    overflow: ", ";\n    text-overflow: ellipsis;\n  }\n\n  ", ";\n  ", ";\n"]);

  return _templateObject$5 = function _templateObject$5() {
    return e;
  }, e;
}

var TableCellStyle = styled__default(Cell)(_templateObject$5(), function (e) {
  return e.theme.rows.fontSize;
}, function (e) {
  return e.column.wrap ? "normal" : "nowrap";
}, function (e) {
  return e.column.allowOverflow ? "visible" : "hidden";
}, function (e) {
  return e.column.style;
}, function (e) {
  return e.extendedCellStyle;
}),
    TableCell = React.memo(function (e) {
  var t = e.id,
      n = e.column,
      r = e.row;
  if (n.omit) return null;
  var o = n.ignoreRowClick || n.button ? null : "___react-data-table-allow-propagation___",
      a = getConditionalStyle(r, n.conditionalCellStyles);
  return React__default.createElement(TableCellStyle, {
    id: t,
    role: "cell",
    column: n,
    "data-tag": o,
    className: "rdt_TableCell",
    extendedCellStyle: a
  }, !n.cell && React__default.createElement("div", {
    "data-tag": o
  }, getProperty(r, n.selector, n.format)), n.cell && n.cell(r));
});
TableCell.propTypes = {
  id: propTypes.string.isRequired,
  column: propTypes.object.isRequired,
  row: propTypes.object.isRequired
};

var calculateBaseStyle = function calculateBaseStyle(e) {
  return _objectSpread2(_objectSpread2({
    fontSize: "18px"
  }, !e && {
    cursor: "pointer"
  }), {}, {
    padding: 0,
    marginTop: "1px",
    verticalAlign: "middle",
    position: "relative"
  });
},
    Checkbox = React.memo(function (e) {
  var t = e.component,
      n = e.componentOptions,
      r = e.indeterminate,
      o = e.checked,
      a = e.name,
      l = e.onClick,
      i = e.disabled,
      c = t,
      p = "input" !== c ? n.style : calculateBaseStyle(i),
      s = React.useMemo(function () {
    return handleFunctionProps(n, r);
  }, [n, r]);
  return React__default.createElement(c, _extends({
    type: "checkbox",
    ref: function ref(e) {
      e && (e.indeterminate = r);
    },
    style: p,
    onClick: i ? noop : l,
    name: a,
    "aria-label": a,
    checked: o,
    disabled: i
  }, s, {
    onChange: noop
  }));
});

function _templateObject$6() {
  var e = _taggedTemplateLiteral(["\n  flex: 0 0 48px;\n  justify-content: center;\n  align-items: center;\n  user-select: none;\n  white-space: nowrap;\n"]);

  return _templateObject$6 = function _templateObject$6() {
    return e;
  }, e;
}

Checkbox.propTypes = {
  name: propTypes.string.isRequired,
  indeterminate: propTypes.bool,
  component: propTypes.oneOfType([propTypes.string, propTypes.node, propTypes.func, propTypes.object]),
  componentOptions: propTypes.object,
  checked: propTypes.bool,
  disabled: propTypes.bool,
  onClick: propTypes.func
}, Checkbox.defaultProps = {
  indeterminate: !1,
  component: "input",
  componentOptions: {
    style: {}
  },
  checked: !1,
  disabled: !1,
  onClick: null
};

var TableCellCheckboxStyle = styled__default(CellBase)(_templateObject$6()),
    TableCellCheckbox = function TableCellCheckbox(e) {
  var t = e.name,
      n = e.row,
      r = e.selected,
      o = useTableContext(),
      a = o.dispatch,
      l = o.data,
      i = o.keyField,
      c = o.selectableRowsComponent,
      p = o.selectableRowsComponentProps,
      s = o.selectableRowDisabled,
      u = s && s(n),
      d = React.useCallback(function () {
    return a({
      type: "SELECT_SINGLE_ROW",
      row: n,
      isSelected: r,
      keyField: i,
      rowCount: l.length
    });
  }, [a, n, r, i, l.length]);
  return React__default.createElement(TableCellCheckboxStyle, {
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    className: "rdt_TableCell",
    noPadding: !0
  }, React__default.createElement(Checkbox, {
    name: t,
    component: c,
    componentOptions: p,
    checked: r,
    "aria-checked": r,
    onClick: d,
    disabled: u
  }));
};

function _templateObject$7() {
  var e = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  user-select: none;\n  white-space: nowrap;\n  border: none;\n  background-color: transparent;\n  ", ";\n"]);

  return _templateObject$7 = function _templateObject$7() {
    return e;
  }, e;
}

TableCellCheckbox.propTypes = {
  name: propTypes.string.isRequired,
  row: propTypes.object.isRequired,
  selected: propTypes.bool.isRequired
};

var ButtonStyle = styled__default.button(_templateObject$7(), function (e) {
  return e.theme.expanderButton.style;
}),
    ExpanderButton = function ExpanderButton(e) {
  var t = e.expanded,
      n = e.row,
      r = e.onToggled,
      o = e.disabled,
      a = useTableContext(),
      l = a.expandableIcon,
      i = a.keyField,
      c = t ? l.expanded : l.collapsed;
  return React__default.createElement(ButtonStyle, {
    "aria-disabled": o,
    onClick: function onClick(e) {
      return r && r(n, e);
    },
    "data-testid": "expander-button-".concat(n[i]),
    disabled: o,
    role: "button",
    type: "button"
  }, c);
};

function _templateObject$8() {
  var e = _taggedTemplateLiteral(["\n  white-space: nowrap;\n  font-weight: 400;\n  ", ";\n"]);

  return _templateObject$8 = function _templateObject$8() {
    return e;
  }, e;
}

ExpanderButton.propTypes = {
  row: propTypes.object.isRequired,
  expanded: propTypes.bool,
  onToggled: propTypes.func,
  disabled: propTypes.bool
}, ExpanderButton.defaultProps = {
  onToggled: null,
  expanded: !1,
  disabled: !1
};

var TableCellExpanderStyle = styled__default(CellBase)(_templateObject$8(), function (e) {
  return e.theme.expanderCell.style;
}),
    TableCellExpander = function TableCellExpander(e) {
  var t = e.column,
      n = e.row,
      r = e.expanded,
      o = e.onRowExpandToggled,
      a = e.disabled;
  return React__default.createElement(TableCellExpanderStyle, {
    column: t,
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    noPadding: !0
  }, React__default.createElement(ExpanderButton, {
    onToggled: o,
    row: n,
    expanded: r,
    disabled: a
  }));
};

function _templateObject$9() {
  var e = _taggedTemplateLiteral(["\n  width: 100%;\n  box-sizing: border-box;\n  ", ";\n  ", ";\n"]);

  return _templateObject$9 = function _templateObject$9() {
    return e;
  }, e;
}

TableCellExpander.propTypes = {
  column: propTypes.object,
  row: propTypes.object,
  expanded: propTypes.bool,
  onRowExpandToggled: propTypes.func.isRequired,
  disabled: propTypes.bool
}, TableCellExpander.defaultProps = {
  column: {},
  row: {},
  expanded: !1,
  disabled: !1
};

var renderChildren = function renderChildren(e, t) {
  return React.Children.map(e, function (e) {
    return React.cloneElement(e, {
      data: t
    });
  });
},
    ExpanderRowStyle = styled__default.div(_templateObject$9(), function (e) {
  return e.theme.expanderRow.style;
}, function (e) {
  return e.extendedRowStyle;
}),
    ExpanderRow = function ExpanderRow(e) {
  var t = e.data,
      n = e.children,
      r = e.extendedRowStyle;
  return React__default.createElement(ExpanderRowStyle, {
    className: "rdt_ExpanderRow",
    extendedRowStyle: r
  }, renderChildren(n, t));
};

function _templateObject3$2() {
  var e = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: stretch;\n  align-content: stretch;\n  width: 100%;\n  box-sizing: border-box;\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"]);

  return _templateObject3$2 = function _templateObject3$2() {
    return e;
  }, e;
}

function _templateObject2$4() {
  var e = _taggedTemplateLiteral(["\n  &:hover {\n    cursor: pointer;\n  }\n"]);

  return _templateObject2$4 = function _templateObject2$4() {
    return e;
  }, e;
}

function _templateObject$a() {
  var e = _taggedTemplateLiteral(["\n  &:hover {\n    ", ";\n  }\n"]);

  return _templateObject$a = function _templateObject$a() {
    return e;
  }, e;
}

ExpanderRow.propTypes = {
  data: propTypes.object,
  children: propTypes.oneOfType([propTypes.arrayOf(propTypes.node), propTypes.node]),
  extendedRowStyle: propTypes.object
}, ExpanderRow.defaultProps = {
  data: {},
  children: null,
  extendedRowStyle: null
};
var STOP_PROP_TAG = "___react-data-table-allow-propagation___",
    highlightCSS = styled.css(_templateObject$a(), function (e) {
  return e.highlightOnHover && e.theme.rows.highlightOnHoverStyle;
}),
    pointerCSS = styled.css(_templateObject2$4()),
    TableRowStyle = styled__default.div(_templateObject3$2(), function (e) {
  return e.theme.rows.style;
}, function (e) {
  return e.dense && e.theme.rows.denseStyle;
}, function (e) {
  return e.striped && e.theme.rows.stripedStyle;
}, function (e) {
  return e.highlightOnHover && highlightCSS;
}, function (e) {
  return e.pointerOnHover && pointerCSS;
}, function (e) {
  return e.selected && e.theme.rows.selectedHighlightStyle;
}, function (e) {
  return e.extendedRowStyle;
}),
    TableRow = React.memo(function (e) {
  var t = e.id,
      n = e.keyField,
      r = e.columns,
      o = e.row,
      a = e.onRowClicked,
      l = e.onRowDoubleClicked,
      i = e.selectableRows,
      c = e.expandableRows,
      p = e.striped,
      s = e.highlightOnHover,
      u = e.pointerOnHover,
      d = e.dense,
      f = e.expandableRowsComponent,
      y = e.defaultExpanderDisabled,
      m = e.defaultExpanded,
      b = e.expandableRowsHideExpander,
      _ = e.expandOnRowClicked,
      g = e.expandOnRowDoubleClicked,
      h = e.conditionalRowStyles,
      v = e.inheritConditionalStyles,
      T = e.onRowExpandToggled,
      w = e.selected,
      R = e.selectableRowsHighlight,
      x = _slicedToArray(React.useState(m), 2),
      O = x[0],
      S = x[1];

  React.useEffect(function () {
    S(m);
  }, [m]);
  var j = React.useCallback(function () {
    S(!O), T(!O, o);
  }, [O, T, o]),
      C = u || c && (_ || g),
      E = React.useCallback(function (e) {
    e.target && e.target.getAttribute("data-tag") === STOP_PROP_TAG && (a(o, e), !y && c && _ && j());
  }, [y, _, c, j, a, o]),
      P = React.useCallback(function (e) {
    e.target && e.target.getAttribute("data-tag") === STOP_PROP_TAG && (l(o, e), !y && c && g && j());
  }, [y, g, c, j, l, o]),
      I = getConditionalStyle(o, h),
      $ = R && w,
      k = v ? I : null;
  return React__default.createElement(React__default.Fragment, null, React__default.createElement(TableRowStyle, {
    id: "row-".concat(t),
    role: "row",
    striped: p,
    highlightOnHover: s,
    pointerOnHover: !y && C,
    dense: d,
    onClick: E,
    onDoubleClick: P,
    className: "rdt_TableRow",
    extendedRowStyle: I,
    selected: $
  }, i && React__default.createElement(TableCellCheckbox, {
    name: "select-row-".concat(o[n]),
    row: o,
    selected: w
  }), c && !b && React__default.createElement(TableCellExpander, {
    expanded: O,
    row: o,
    onRowExpandToggled: j,
    disabled: y
  }), r.map(function (e) {
    return React__default.createElement(TableCell, {
      id: "cell-".concat(e.id, "-").concat(o[n]),
      key: "cell-".concat(e.id, "-").concat(o[n]),
      column: e,
      row: o
    });
  })), c && O && React__default.createElement(ExpanderRow, {
    key: "expander--".concat(o[n]),
    data: o,
    extendedRowStyle: k
  }, f));
});

function _templateObject$b() {
  var e = _taggedTemplateLiteral(["\n  padding: 2px;\n  color: inherit;\n  flex-grow: 0;\n  flex-shrink: 0;\n  ", ";\n  ", ";\n"]);

  return _templateObject$b = function _templateObject$b() {
    return e;
  }, e;
}

TableRow.propTypes = {
  id: propTypes.any.isRequired,
  keyField: propTypes.string.isRequired,
  columns: propTypes.array.isRequired,
  row: propTypes.object.isRequired,
  onRowClicked: propTypes.func.isRequired,
  onRowDoubleClicked: propTypes.func.isRequired,
  onRowExpandToggled: propTypes.func.isRequired,
  defaultExpanded: propTypes.bool,
  defaultExpanderDisabled: propTypes.bool,
  selectableRows: propTypes.bool.isRequired,
  expandableRows: propTypes.bool.isRequired,
  striped: propTypes.bool.isRequired,
  highlightOnHover: propTypes.bool.isRequired,
  pointerOnHover: propTypes.bool.isRequired,
  dense: propTypes.bool.isRequired,
  expandableRowsComponent: propTypes.oneOfType([propTypes.arrayOf(propTypes.node), propTypes.node, propTypes.func]).isRequired,
  expandableRowsHideExpander: propTypes.bool.isRequired,
  expandOnRowClicked: propTypes.bool.isRequired,
  expandOnRowDoubleClicked: propTypes.bool.isRequired,
  conditionalRowStyles: propTypes.array.isRequired,
  inheritConditionalStyles: propTypes.bool.isRequired,
  selected: propTypes.bool.isRequired,
  selectableRowsHighlight: propTypes.bool.isRequired
}, TableRow.defaultProps = {
  defaultExpanded: !1,
  defaultExpanderDisabled: !1
};

var Icon = styled__default.span(_templateObject$b(), function (e) {
  return e.sortActive ? "opacity: 1" : "opacity: 0";
}, function (e) {
  return "desc" === e.sortDirection && "transform: rotate(180deg)";
}),
    NativeSortIcon = function NativeSortIcon(e) {
  var t = e.sortActive,
      n = e.sortDirection,
      r = e.sortIcon;
  return React__default.createElement(Icon, {
    sortActive: t,
    sortDirection: n
  }, r);
};

function _templateObject2$5() {
  var e = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  height: 100%;\n  line-height: 1;\n  user-select: none;\n  ", ";\n\n  span.__rdt_custom_sort_icon__ {\n    i,\n    svg {\n      ", ";\n      color: inherit;\n      font-size: 18px !important;\n      height: 18px !important;\n      width: 18px !important;\n      backface-visibility: hidden;\n      transform-style: preserve-3d;\n      transition-duration: 125ms;\n      transition-property: transform;\n    }\n\n    &.asc i,\n    &.asc svg {\n      transform: rotate(180deg);\n    }\n  }\n\n  &:hover {\n    ", ";\n    ", ";\n\n    span,\n    span.__rdt_custom_sort_icon__ * {\n      ", ";\n    }\n  }\n"]);

  return _templateObject2$5 = function _templateObject2$5() {
    return e;
  }, e;
}

function _templateObject$c() {
  var e = _taggedTemplateLiteral(["\n  ", ";\n"]);

  return _templateObject$c = function _templateObject$c() {
    return e;
  }, e;
}

NativeSortIcon.propTypes = {
  sortDirection: propTypes.string.isRequired,
  sortActive: propTypes.bool,
  sortIcon: propTypes.node
}, NativeSortIcon.defaultProps = {
  sortActive: !1,
  sortIcon: React__default.createElement(React__default.Fragment, null, "▲")
};
var TableColStyle = styled__default(Cell)(_templateObject$c(), function (e) {
  return e.column.button && "text-align: center";
}),
    ColumnSortable = styled__default.div(_templateObject2$5(), function (e) {
  return e.sortActive ? e.theme.headCells.activeSortStyle : e.theme.headCells.inactiveSortStyle;
}, function (e) {
  return e.sortActive ? "opacity: 1" : "opacity: 0";
}, function (e) {
  return e.column.sortable && "cursor: pointer";
}, function (e) {
  var t = e.column,
      n = e.theme;
  return t.sortable && n.headCells.activeStyle;
}, function (e) {
  var t = e.sortActive,
      n = e.column;
  return !t && n.sortable && "opacity: 1";
}),
    TableCol = React.memo(function (e) {
  var t = e.column,
      n = e.sortIcon,
      r = useTableContext(),
      o = r.dispatch,
      a = r.pagination,
      l = r.paginationServer,
      i = r.sortColumn,
      c = r.sortDirection,
      p = r.sortServer,
      s = r.selectableRowsVisibleOnly,
      u = r.persistSelectedOnSort;
  if (t.omit) return null;

  function d() {
    if (t.sortable) {
      var e = c;
      i === t.selector && (e = "asc" === c ? "desc" : "asc"), o({
        type: "SORT_CHANGE",
        sortDirection: e,
        sortColumn: t.selector,
        sortServer: p,
        selectedColumn: t,
        pagination: a,
        paginationServer: l,
        visibleOnly: s,
        persistSelectedOnSort: u
      });
    }
  }

  function f(e) {
    return React__default.createElement(NativeSortIcon, {
      column: t,
      sortActive: e,
      sortDirection: c
    });
  }

  function y() {
    return React__default.createElement("span", {
      className: [c, "__rdt_custom_sort_icon__"].join(" ")
    }, n);
  }

  var m = t.sortable && i === t.selector,
      b = t.sortable && !n && !t.right,
      _ = t.sortable && !n && t.right,
      g = t.sortable && n && !t.right,
      h = t.sortable && n && t.right;

  return React__default.createElement(TableColStyle, {
    className: "rdt_TableCol",
    column: t,
    head: !0
  }, t.name && React__default.createElement(ColumnSortable, {
    id: "column-".concat(t.selector),
    role: "button",
    "aria-pressed": m,
    tabIndex: 0,
    className: "rdt_TableCol_Sortable",
    onClick: d,
    onKeyPress: function onKeyPress(e) {
      "Enter" === e.key && d();
    },
    sortActive: m,
    column: t
  }, h && y(), _ && f(m), React__default.createElement("div", null, t.name), g && y(), b && f(m)));
});

function _templateObject$d() {
  var e = _taggedTemplateLiteral(["\n  flex: 0 0 48px;\n  justify-content: center;\n  align-items: center;\n  user-select: none;\n  white-space: nowrap;\n"]);

  return _templateObject$d = function _templateObject$d() {
    return e;
  }, e;
}

TableCol.propTypes = {
  column: propTypes.object.isRequired,
  sortIcon: propTypes.oneOfType([propTypes.bool, propTypes.object]).isRequired
};

var TableColStyle$1 = styled__default(CellBase)(_templateObject$d()),
    TableColCheckbox = function TableColCheckbox(e) {
  var t = e.head,
      n = useTableContext(),
      r = n.dispatch,
      o = n.data,
      a = n.selectedRows,
      l = n.allSelected,
      i = n.selectableRowsComponent,
      c = n.selectableRowsComponentProps,
      p = n.selectableRowDisabled,
      s = n.keyField,
      u = n.mergeSelections,
      d = 0 < a.length && !l,
      f = p ? o.filter(function (e) {
    return !p(e);
  }) : o,
      y = 0 === f.length,
      m = o.length,
      b = React.useCallback(function () {
    return r({
      type: "SELECT_ALL_ROWS",
      rows: f,
      rowCount: m,
      mergeSelections: u,
      keyField: s
    });
  }, [r, s, u, m, f]);
  return React__default.createElement(TableColStyle$1, {
    className: "rdt_TableCol",
    head: t,
    noPadding: !0
  }, React__default.createElement(Checkbox, {
    name: "select-all-rows",
    component: i,
    componentOptions: c,
    onClick: b,
    checked: l,
    indeterminate: d,
    disabled: y
  }));
};

function _templateObject3$3() {
  var e = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  box-sizing: inherit;\n  z-index: 1;\n  align-items: center;\n  justify-content: space-between;\n  display: flex;\n  ", ";\n  ", ";\n"]);

  return _templateObject3$3 = function _templateObject3$3() {
    return e;
  }, e;
}

function _templateObject2$6() {
  var e = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n"]);

  return _templateObject2$6 = function _templateObject2$6() {
    return e;
  }, e;
}

function _templateObject$e() {
  var e = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  flex: 1 0 auto;\n  height: 100%;\n  color: ", ";\n  font-size: ", ";\n  font-weight: 400;\n"]);

  return _templateObject$e = function _templateObject$e() {
    return e;
  }, e;
}

TableColCheckbox.propTypes = {
  head: propTypes.bool
}, TableColCheckbox.defaultProps = {
  head: !0
};

var Title = styled__default.div(_templateObject$e(), function (e) {
  return e.theme.contextMenu.fontColor;
}, function (e) {
  return e.theme.contextMenu.fontSize;
}),
    ContextActions = styled__default.div(_templateObject2$6()),
    ContextMenuStyle = styled__default.div(_templateObject3$3(), function (e) {
  return e.theme.contextMenu.style;
}, function (e) {
  return e.visible && e.theme.contextMenu.activeStyle;
}),
    generateDefaultContextTitle = function generateDefaultContextTitle(e, t, n) {
  if (0 === t) return null;
  var r = 1 === t ? e.singular : e.plural;
  return detectRTL(n) ? "".concat(t, " ").concat(e.message || "", " ").concat(r) : "".concat(t, " ").concat(r, " ").concat(e.message || "");
},
    ContextMenu = function ContextMenu() {
  var e = useTableContext(),
      t = e.contextMessage,
      n = e.contextActions,
      r = e.contextComponent,
      o = e.selectedCount,
      a = e.direction,
      l = 0 < o;
  return r ? React__default.createElement(ContextMenuStyle, {
    visible: l
  }, React.cloneElement(r, {
    selectedCount: o
  })) : React__default.createElement(ContextMenuStyle, {
    visible: l
  }, React__default.createElement(Title, null, generateDefaultContextTitle(t, o, a)), React__default.createElement(ContextActions, null, n));
};

function _templateObject3$4() {
  var e = _taggedTemplateLiteral(["\n  flex: 1 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n\n  > * {\n    margin-left: 5px;\n  }\n"]);

  return _templateObject3$4 = function _templateObject3$4() {
    return e;
  }, e;
}

function _templateObject2$7() {
  var e = _taggedTemplateLiteral(["\n  flex: 1 0 auto;\n  color: ", ";\n  font-size: ", ";\n  font-weight: 400;\n"]);

  return _templateObject2$7 = function _templateObject2$7() {
    return e;
  }, e;
}

function _templateObject$f() {
  var e = _taggedTemplateLiteral(["\n  position: relative;\n  box-sizing: border-box;\n  overflow: visible;\n  display: flex;\n  flex: 1 1 auto;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  flex-wrap: wrap;\n  ", "\n"]);

  return _templateObject$f = function _templateObject$f() {
    return e;
  }, e;
}

var TableHeaderStyle = styled__default.header(_templateObject$f(), function (e) {
  return e.theme.header.style;
}),
    Title$1 = styled__default.div(_templateObject2$7(), function (e) {
  return e.theme.header.fontColor;
}, function (e) {
  return e.theme.header.fontSize;
}),
    Actions = styled__default.div(_templateObject3$4()),
    TableHeader = function TableHeader(e) {
  var t = e.title,
      n = e.actions,
      r = e.showMenu;
  return React__default.createElement(TableHeaderStyle, {
    className: "rdt_TableHeader"
  }, React__default.createElement(Title$1, null, t), React__default.createElement(Actions, null, n), r && React__default.createElement(ContextMenu, null));
};

function _templateObject$g() {
  var e = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  flex: 1 1 auto;\n  box-sizing: border-box;\n  align-items: center;\n  padding: 4px 16px 4px 24px;\n  width: 100%;\n  justify-content: ", ";\n  flex-wrap: ", ";\n  ", "\n"]);

  return _templateObject$g = function _templateObject$g() {
    return e;
  }, e;
}

TableHeader.propTypes = {
  title: propTypes.oneOfType([propTypes.string, propTypes.node]).isRequired,
  actions: propTypes.oneOfType([propTypes.arrayOf(propTypes.node), propTypes.node]),
  showMenu: propTypes.bool
}, TableHeader.defaultProps = {
  actions: [],
  showMenu: !0
};

var alignMap = {
  left: "flex-start",
  right: "flex-end",
  center: "center"
},
    SubheaderWrapper = styled__default.header(_templateObject$g(), function (e) {
  return alignMap[e.align];
}, function (e) {
  return e.wrapContent ? "wrap" : "nowrap";
}, function (e) {
  return e.theme.subHeader.style;
}),
    TableSubheader = function TableSubheader(e) {
  var t = e.align,
      n = e.wrapContent,
      r = e.children;
  return React__default.createElement(SubheaderWrapper, {
    align: t,
    wrapContent: n
  }, r);
};

function _templateObject2$8() {
  var e = _taggedTemplateLiteral(["\n    max-height: ", ";\n    overflow-y: scroll;\n    -webkit-overflow-scrolling: touch;\n  "]);

  return _templateObject2$8 = function _templateObject2$8() {
    return e;
  }, e;
}

function _templateObject$h() {
  var e = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  ", ";\n"]);

  return _templateObject$h = function _templateObject$h() {
    return e;
  }, e;
}

TableSubheader.propTypes = {
  children: propTypes.oneOfType([propTypes.arrayOf(propTypes.node), propTypes.node, propTypes.string]),
  align: propTypes.oneOf(["center", "left", "right"]),
  wrapContent: propTypes.bool
}, TableSubheader.defaultProps = {
  children: null,
  align: "right",
  wrapContent: !0
};
var TableBody = styled__default.div(_templateObject$h(), function (e) {
  var t = e.fixedHeader,
      n = e.hasOffset,
      r = e.offset,
      o = e.fixedHeaderScrollHeight;
  return t && styled.css(_templateObject2$8(), n ? "calc(".concat(o, " - ").concat(r, ")") : o);
});

function _templateObject3$5() {
  var e = _taggedTemplateLiteral(["\n    padding-bottom: ", ";\n    margin-bottom: -", ";\n  "]);

  return _templateObject3$5 = function _templateObject3$5() {
    return e;
  }, e;
}

function _templateObject2$9() {
  var e = _taggedTemplateLiteral(["\n    overflow-x: auto;\n\n    // prevents vertical scrolling in firefox\n    overflow-y: hidden;\n    min-height: 0;\n  "]);

  return _templateObject2$9 = function _templateObject2$9() {
    return e;
  }, e;
}

function _templateObject$i() {
  var e = _taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n  ", ";\n  ", ";\n"]);

  return _templateObject$i = function _templateObject$i() {
    return e;
  }, e;
}

TableBody.defaultProps = {
  fixedHeaderScrollHeight: "100vh",
  offset: 0
};
var ResponsiveWrapper = styled__default.div(_templateObject$i(), function (e) {
  return e.responsive && styled.css(_templateObject2$9());
}, function (e) {
  return e.overflowY && e.responsive && e.overflowYOffset && styled.css(_templateObject3$5(), e.overflowYOffset, e.overflowYOffset);
});

function _templateObject$j() {
  var e = _taggedTemplateLiteral(["\n  position: relative;\n  box-sizing: border-box;\n  width: 100%;\n  height: 100%;\n  ", ";\n"]);

  return _templateObject$j = function _templateObject$j() {
    return e;
  }, e;
}

var ProgressWrapperStyle = styled__default.div(_templateObject$j(), function (e) {
  return e.theme.progress.style;
}),
    ProgressWrapper = function ProgressWrapper(e) {
  var t = e.children;
  return React__default.createElement(ProgressWrapperStyle, null, t);
};

function _templateObject$k() {
  var e = _taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n  ", ";\n"]);

  return _templateObject$k = function _templateObject$k() {
    return e;
  }, e;
}

ProgressWrapper.propTypes = {
  children: propTypes.oneOfType([propTypes.string, propTypes.node, propTypes.func]).isRequired
};
var TableWrapper = styled__default.div(_templateObject$k(), function (e) {
  return e.theme.tableWrapper.style;
});

function _templateObject$l() {
  var e = _taggedTemplateLiteral(["\n  white-space: nowrap;\n  ", ";\n"]);

  return _templateObject$l = function _templateObject$l() {
    return e;
  }, e;
}

var TableColExpander = styled__default(CellBase)(_templateObject$l(), function (e) {
  return e.theme.expanderCell.style;
});

function _templateObject$m() {
  var e = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  width: 100%;\n  height: 100%;\n  ", ";\n"]);

  return _templateObject$m = function _templateObject$m() {
    return e;
  }, e;
}

var NoDataWrapperStyle = styled__default.div(_templateObject$m(), function (e) {
  return e.theme.noData.style;
}),
    NoDataWrapper = function NoDataWrapper(e) {
  var t = e.children;
  return React__default.createElement(NoDataWrapperStyle, null, t);
};

NoDataWrapper.propTypes = {
  children: propTypes.oneOfType([propTypes.string, propTypes.node]).isRequired
};

var DropDownIcon = function DropDownIcon() {
  return React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, React__default.createElement("path", {
    d: "M7 10l5 5 5-5z"
  }), React__default.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
};

function _templateObject2$a() {
  var e = _taggedTemplateLiteral(["\n  position: relative;\n  flex-shrink: 0;\n  font-size: inherit;\n  color: inherit;\n  margin-top: 1px;\n\n  svg {\n    top: 0;\n    right: 0;\n    color: inherit;\n    position: absolute;\n    fill: currentColor;\n    width: 24px;\n    height: 24px;\n    display: inline-block;\n    user-select: none;\n    pointer-events: none;\n  }\n"]);

  return _templateObject2$a = function _templateObject2$a() {
    return e;
  }, e;
}

function _templateObject$n() {
  var e = _taggedTemplateLiteral(["\n  cursor: pointer;\n  height: 24px;\n  min-width: 24px;\n  user-select: none;\n  padding-left: 8px;\n  padding-right: 12px;\n  box-sizing: content-box;\n  font-size: inherit;\n  color: inherit;\n  border: none;\n  background-color: transparent;\n  appearance: none;\n  direction: ltr;\n\n  &::-ms-expand {\n    display: none;\n  }\n\n  &:disabled::-ms-expand {\n    background: #f60;\n  }\n"]);

  return _templateObject$n = function _templateObject$n() {
    return e;
  }, e;
}

var SelectControl = styled__default.select(_templateObject$n()),
    SelectWrapper = styled__default.div(_templateObject2$a()),
    Select = function Select(e) {
  return React__default.createElement(SelectWrapper, null, React__default.createElement(SelectControl, e), React__default.createElement(DropDownIcon, null));
};

function useWindowSize() {
  var t = "object" === ("undefined" == typeof window ? "undefined" : _typeof(window));

  function n() {
    return {
      width: t ? window.innerWidth : void 0,
      height: t ? window.innerHeight : void 0
    };
  }

  var e = _slicedToArray(React.useState(n), 2),
      r = e[0],
      o = e[1];

  return React.useEffect(function () {
    if (!t) return !1;

    function e() {
      o(n());
    }

    return window.addEventListener("resize", e), function () {
      return window.removeEventListener("resize", e);
    };
  }, []), r;
}

function _templateObject7$1() {
  var e = _taggedTemplateLiteral(["\n  margin: 0 4px;\n"]);

  return _templateObject7$1 = function _templateObject7$1() {
    return e;
  }, e;
}

function _templateObject6$1() {
  var e = _taggedTemplateLiteral(["\n  margin: 0 24px;\n"]);

  return _templateObject6$1 = function _templateObject6$1() {
    return e;
  }, e;
}

function _templateObject5$1() {
  var e = _taggedTemplateLiteral(["\n  flex-shrink: 1;\n  user-select: none;\n"]);

  return _templateObject5$1 = function _templateObject5$1() {
    return e;
  }, e;
}

function _templateObject4$2() {
  var e = _taggedTemplateLiteral(["\n    width: 100%;\n    justify-content: space-around;\n  "]);

  return _templateObject4$2 = function _templateObject4$2() {
    return e;
  }, e;
}

function _templateObject3$6() {
  var e = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  border-radius: 4px;\n  white-space: nowrap;\n  ", ";\n"]);

  return _templateObject3$6 = function _templateObject3$6() {
    return e;
  }, e;
}

function _templateObject2$b() {
  var e = _taggedTemplateLiteral(["\n  position: relative;\n  display: block;\n  user-select: none;\n  border: none;\n  ", ";\n  ", ";\n"]);

  return _templateObject2$b = function _templateObject2$b() {
    return e;
  }, e;
}

function _templateObject$o() {
  var e = _taggedTemplateLiteral(["\n  display: flex;\n  flex: 1 1 auto;\n  justify-content: flex-end;\n  align-items: center;\n  box-sizing: border-box;\n  padding-right: 8px;\n  padding-left: 8px;\n  width: 100%;\n  ", ";\n"]);

  return _templateObject$o = function _templateObject$o() {
    return e;
  }, e;
}

var defaultComponentOptions = {
  rowsPerPageText: "Rows per page:",
  rangeSeparatorText: "of",
  noRowsPerPage: !1,
  selectAllRowsItem: !1,
  selectAllRowsItemText: "All"
},
    PaginationWrapper = styled__default.nav(_templateObject$o(), function (e) {
  return e.theme.pagination.style;
}),
    Button = styled__default.button(_templateObject2$b(), function (e) {
  return e.theme.pagination.pageButtonsStyle;
}, function (e) {
  return e.isRTL && "transform: scale(-1, -1)";
}),
    PageList = styled__default.div(_templateObject3$6(), media.sm(_templateObject4$2())),
    Span = styled__default.span(_templateObject5$1()),
    Range = styled__default(Span)(_templateObject6$1()),
    RowLabel = styled__default(Span)(_templateObject7$1()),
    Pagination = function Pagination(e) {
  var t = e.rowsPerPage,
      n = e.rowCount,
      r = e.onChangePage,
      o = e.onChangeRowsPerPage,
      a = e.currentPage,
      l = useTableContext(),
      i = l.direction,
      c = l.paginationRowsPerPageOptions,
      p = l.paginationIconLastPage,
      s = l.paginationIconFirstPage,
      u = l.paginationIconNext,
      d = l.paginationIconPrevious,
      f = l.paginationComponentOptions,
      y = useWindowSize().width > SMALL,
      m = detectRTL(i),
      b = getNumberOfPages(n, t),
      _ = a * t,
      g = _ - t + 1,
      h = 1 === a,
      v = a === b,
      T = _objectSpread2(_objectSpread2({}, defaultComponentOptions), f),
      w = a === b ? "".concat(g, "-").concat(n, " ").concat(T.rangeSeparatorText, " ").concat(n) : "".concat(g, "-").concat(_, " ").concat(T.rangeSeparatorText, " ").concat(n),
      R = React.useCallback(function () {
    return r(a - 1);
  }, [a, r]),
      x = React.useCallback(function () {
    return r(a + 1);
  }, [a, r]),
      O = React.useCallback(function () {
    return r(1);
  }, [r]),
      S = React.useCallback(function () {
    return r(getNumberOfPages(n, t));
  }, [r, n, t]),
      j = React.useCallback(function (e) {
    var t = e.target;
    return o(Number(t.value), a);
  }, [a, o]),
      C = c.map(function (e) {
    return React__default.createElement("option", {
      key: e,
      value: e
    }, e);
  });

  T.selectAllRowsItem && C.push(React__default.createElement("option", {
    key: -1,
    value: n
  }, T.selectAllRowsItemText));
  var E = React__default.createElement(Select, {
    onChange: j,
    defaultValue: t
  }, C);
  return React__default.createElement(PaginationWrapper, {
    className: "rdt_Pagination"
  }, !T.noRowsPerPage && y && React__default.createElement(React__default.Fragment, null, React__default.createElement(RowLabel, null, T.rowsPerPageText), E), y && React__default.createElement(Range, null, w), React__default.createElement(PageList, null, React__default.createElement(Button, {
    id: "pagination-first-page",
    type: "button",
    "aria-label": "First Page",
    "aria-disabled": h,
    onClick: O,
    disabled: h,
    isRTL: m
  }, s), React__default.createElement(Button, {
    id: "pagination-previous-page",
    type: "button",
    "aria-label": "Previous Page",
    "aria-disabled": h,
    onClick: R,
    disabled: h,
    isRTL: m
  }, d), !y && E, React__default.createElement(Button, {
    id: "pagination-next-page",
    type: "button",
    "aria-label": "Next Page",
    "aria-disabled": v,
    onClick: x,
    disabled: v,
    isRTL: m
  }, u), React__default.createElement(Button, {
    id: "pagination-last-page",
    type: "button",
    "aria-label": "Last Page",
    "aria-disabled": v,
    onClick: S,
    disabled: v,
    isRTL: m
  }, p)));
};

function useFirstUpdate(e, t) {
  var n = React.useRef(!0);
  React.useEffect(function () {
    n.current ? n.current = !1 : e();
  }, t);
}

Pagination.propTypes = {
  rowsPerPage: propTypes.number.isRequired,
  rowCount: propTypes.number.isRequired,
  onChangePage: propTypes.func.isRequired,
  onChangeRowsPerPage: propTypes.func.isRequired,
  currentPage: propTypes.number.isRequired
};

var FirstPageIcon = function FirstPageIcon() {
  return React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    role: "presentation"
  }, React__default.createElement("path", {
    d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"
  }), React__default.createElement("path", {
    fill: "none",
    d: "M24 24H0V0h24v24z"
  }));
},
    LastPageIcon = function LastPageIcon() {
  return React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    role: "presentation"
  }, React__default.createElement("path", {
    d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"
  }), React__default.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }));
},
    LeftIcon = function LeftIcon() {
  return React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    role: "presentation"
  }, React__default.createElement("path", {
    d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
  }), React__default.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
},
    RightIcon = function RightIcon() {
  return React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    role: "presentation"
  }, React__default.createElement("path", {
    d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
  }), React__default.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
},
    ExpanderCollapsedIcon = function ExpanderCollapsedIcon() {
  return React__default.createElement("svg", {
    fill: "currentColor",
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg"
  }, React__default.createElement("path", {
    d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
  }), React__default.createElement("path", {
    d: "M0-.25h24v24H0z",
    fill: "none"
  }));
},
    ExpanderExpandedIcon = function ExpanderExpandedIcon() {
  return React__default.createElement("svg", {
    fill: "currentColor",
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg"
  }, React__default.createElement("path", {
    d: "M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"
  }), React__default.createElement("path", {
    d: "M0-.75h24v24H0z",
    fill: "none"
  }));
},
    propTypes$1 = {
  title: propTypes.oneOfType([propTypes.string, propTypes.node]),
  selectableRows: propTypes.bool,
  selectableRowsHighlight: propTypes.bool,
  selectableRowsVisibleOnly: propTypes.bool,
  selectableRowsNoSelectAll: propTypes.bool,
  selectableRowSelected: propTypes.func,
  selectableRowDisabled: propTypes.func,
  selectableRowsComponent: propTypes.oneOfType([propTypes.string, propTypes.node, propTypes.func, propTypes.object]),
  selectableRowsComponentProps: propTypes.object,
  onRowsSelectedUpdate: propTypes.func,
  clearSelectedRows: propTypes.bool,
  expandableRows: propTypes.bool,
  expandableRowDisabled: propTypes.func,
  expandableRowExpanded: propTypes.func,
  expandOnRowClicked: propTypes.bool,
  expandableRowsHideExpander: propTypes.bool,
  expandOnRowDoubleClicked: propTypes.bool,
  onRowExpandToggled: propTypes.func,
  expandableInheritConditionalStyles: propTypes.bool,
  keyField: propTypes.string,
  progressPending: propTypes.bool,
  progressComponent: propTypes.oneOfType([propTypes.string, propTypes.node, propTypes.func]),
  persistTableHead: propTypes.bool,
  expandableRowsComponent: propTypes.oneOfType([propTypes.arrayOf(propTypes.node), propTypes.node, propTypes.func]),
  expandableIcon: propTypes.shape({
    collapsed: propTypes.oneOfType([propTypes.string, propTypes.node, propTypes.func]),
    expanded: propTypes.oneOfType([propTypes.string, propTypes.node, propTypes.func])
  }),
  sortIcon: propTypes.oneOfType([propTypes.bool, propTypes.node]),
  sortFunction: propTypes.func,
  sortServer: propTypes.bool,
  onSort: propTypes.func,
  striped: propTypes.bool,
  highlightOnHover: propTypes.bool,
  pointerOnHover: propTypes.bool,
  actions: propTypes.oneOfType([propTypes.arrayOf(propTypes.node), propTypes.node]),
  noContextMenu: propTypes.bool,
  contextMessage: propTypes.shape({
    singular: propTypes.string.isRequired,
    plural: propTypes.string.isRequired,
    message: propTypes.string
  }),
  contextActions: propTypes.oneOfType([propTypes.arrayOf(propTypes.node), propTypes.node]),
  contextComponent: propTypes.oneOfType([propTypes.node, propTypes.func]),
  defaultSortField: propTypes.string,
  defaultSortAsc: propTypes.bool,
  columns: propTypes.array,
  data: propTypes.array,
  className: propTypes.string,
  style: propTypes.object,
  responsive: propTypes.bool,
  overflowY: propTypes.bool,
  overflowYOffset: propTypes.string,
  noDataComponent: propTypes.oneOfType([propTypes.string, propTypes.node, propTypes.func]),
  disabled: propTypes.bool,
  noTableHead: propTypes.bool,
  noHeader: propTypes.bool,
  subHeader: propTypes.bool,
  subHeaderAlign: propTypes.string,
  subHeaderWrap: propTypes.bool,
  subHeaderComponent: propTypes.oneOfType([propTypes.arrayOf(propTypes.node), propTypes.node, propTypes.string]),
  onRowClicked: propTypes.func,
  onRowDoubleClicked: propTypes.func,
  fixedHeader: propTypes.bool,
  fixedHeaderScrollHeight: propTypes.string,
  pagination: propTypes.bool,
  paginationServer: propTypes.bool,
  paginationServerOptions: propTypes.shape({
    persistSelectedOnSort: propTypes.bool,
    persistSelectedOnPageChange: propTypes.bool
  }),
  paginationDefaultPage: propTypes.number,
  paginationResetDefaultPage: propTypes.bool,
  paginationTotalRows: propTypes.number,
  paginationPerPage: propTypes.number,
  paginationRowsPerPageOptions: propTypes.array,
  onChangePage: propTypes.func,
  onChangeRowsPerPage: propTypes.func,
  paginationComponent: propTypes.oneOfType([propTypes.arrayOf(propTypes.node), propTypes.node, propTypes.func]),
  paginationComponentOptions: propTypes.object,
  paginationIconFirstPage: propTypes.oneOfType([propTypes.string, propTypes.node, propTypes.func]),
  paginationIconLastPage: propTypes.oneOfType([propTypes.string, propTypes.node, propTypes.func]),
  paginationIconNext: propTypes.oneOfType([propTypes.string, propTypes.node, propTypes.func]),
  paginationIconPrevious: propTypes.oneOfType([propTypes.string, propTypes.node, propTypes.func]),
  dense: propTypes.bool,
  conditionalRowStyles: propTypes.arrayOf(propTypes.shape({
    when: propTypes.func.isRequired,
    style: propTypes.object.isRequired
  })),
  theme: propTypes.string,
  customStyles: propTypes.object,
  direction: propTypes.oneOf(["ltr", "rtl", "auto"])
},
    defaultProps = {
  title: "",
  keyField: "id",
  selectableRows: !1,
  selectableRowsHighlight: !1,
  selectableRowsNoSelectAll: !1,
  selectableRowSelected: null,
  selectableRowDisabled: null,
  selectableRowsComponent: "input",
  selectableRowsComponentProps: {},
  onSelectedRowsChange: function onSelectedRowsChange() {
    return null;
  },
  clearSelectedRows: !1,
  expandableRows: !1,
  expandableRowDisabled: null,
  expandableRowExpanded: null,
  expandOnRowClicked: !1,
  expandableRowsHideExpander: !1,
  expandOnRowDoubleClicked: !1,
  expandableInheritConditionalStyles: !1,
  onRowExpandToggled: function onRowExpandToggled() {
    return null;
  },
  progressPending: !1,
  progressComponent: React__default.createElement("div", {
    style: {
      fontSize: "24px",
      fontWeight: 700,
      padding: "24px"
    }
  }, "Loading..."),
  persistTableHead: !1,
  expandableRowsComponent: React__default.createElement("div", {
    style: {
      padding: "24px"
    }
  }, "Add a custom expander component. Use props.data for row data"),
  expandableIcon: {
    collapsed: React__default.createElement(ExpanderCollapsedIcon, null),
    expanded: React__default.createElement(ExpanderExpandedIcon, null)
  },
  sortIcon: !1,
  sortFunction: null,
  sortServer: !1,
  onSort: function onSort() {
    return null;
  },
  striped: !1,
  highlightOnHover: !1,
  pointerOnHover: !1,
  noContextMenu: !1,
  contextMessage: {
    singular: "item",
    plural: "items",
    message: "selected"
  },
  contextActions: [],
  contextComponent: null,
  defaultSortField: null,
  defaultSortAsc: !0,
  columns: [],
  data: [],
  className: null,
  style: {},
  responsive: !0,
  overflowY: !1,
  overflowYOffset: "250px",
  noDataComponent: React__default.createElement("div", {
    style: {
      padding: "24px"
    }
  }, "There are no records to display"),
  disabled: !1,
  noTableHead: !1,
  noHeader: !1,
  subHeader: !1,
  subHeaderAlign: "right",
  subHeaderWrap: !0,
  subHeaderComponent: [],
  onRowClicked: function onRowClicked() {
    return null;
  },
  onRowDoubleClicked: function onRowDoubleClicked() {
    return null;
  },
  fixedHeader: !1,
  fixedHeaderScrollHeight: "100vh",
  pagination: !1,
  paginationServer: !1,
  paginationServerOptions: {
    persistSelectedOnSort: !1,
    persistSelectedOnPageChange: !1
  },
  paginationDefaultPage: 1,
  paginationResetDefaultPage: !1,
  paginationTotalRows: 0,
  paginationPerPage: 10,
  paginationRowsPerPageOptions: [10, 15, 20, 25, 30],
  onChangePage: function onChangePage() {
    return null;
  },
  onChangeRowsPerPage: function onChangeRowsPerPage() {
    return null;
  },
  paginationComponent: null,
  paginationComponentOptions: {},
  paginationIconFirstPage: React__default.createElement(FirstPageIcon, null),
  paginationIconLastPage: React__default.createElement(LastPageIcon, null),
  paginationIconNext: React__default.createElement(RightIcon, null),
  paginationIconPrevious: React__default.createElement(LeftIcon, null),
  dense: !1,
  conditionalRowStyles: [],
  theme: "default",
  customStyles: {},
  direction: "auto"
},
    isMergeableObject = function isMergeableObject(e) {
  return isNonNullObject(e) && !isSpecial(e);
};

function isNonNullObject(e) {
  return !!e && "object" == typeof e;
}

function isSpecial(e) {
  var t = Object.prototype.toString.call(e);
  return "[object RegExp]" === t || "[object Date]" === t || isReactElement(e);
}

var canUseSymbol = "function" == typeof Symbol && Symbol.for,
    REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for("react.element") : 60103;

function isReactElement(e) {
  return e.$$typeof === REACT_ELEMENT_TYPE;
}

function emptyTarget(e) {
  return Array.isArray(e) ? [] : {};
}

function cloneUnlessOtherwiseSpecified(e, t) {
  return !1 !== t.clone && t.isMergeableObject(e) ? deepmerge(emptyTarget(e), e, t) : e;
}

function defaultArrayMerge(e, t, n) {
  return e.concat(t).map(function (e) {
    return cloneUnlessOtherwiseSpecified(e, n);
  });
}

function getMergeFunction(e, t) {
  if (!t.customMerge) return deepmerge;
  var n = t.customMerge(e);
  return "function" == typeof n ? n : deepmerge;
}

function getEnumerableOwnPropertySymbols(t) {
  return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(t).filter(function (e) {
    return t.propertyIsEnumerable(e);
  }) : [];
}

function getKeys(e) {
  return Object.keys(e).concat(getEnumerableOwnPropertySymbols(e));
}

function propertyIsOnObject(e, t) {
  try {
    return t in e;
  } catch (e) {
    return !1;
  }
}

function propertyIsUnsafe(e, t) {
  return propertyIsOnObject(e, t) && !(Object.hasOwnProperty.call(e, t) && Object.propertyIsEnumerable.call(e, t));
}

function mergeObject(t, n, r) {
  var o = {};
  return r.isMergeableObject(t) && getKeys(t).forEach(function (e) {
    o[e] = cloneUnlessOtherwiseSpecified(t[e], r);
  }), getKeys(n).forEach(function (e) {
    propertyIsUnsafe(t, e) || (propertyIsOnObject(t, e) && r.isMergeableObject(n[e]) ? o[e] = getMergeFunction(e, r)(t[e], n[e], r) : o[e] = cloneUnlessOtherwiseSpecified(n[e], r));
  }), o;
}

function deepmerge(e, t, n) {
  (n = n || {}).arrayMerge = n.arrayMerge || defaultArrayMerge, n.isMergeableObject = n.isMergeableObject || isMergeableObject, n.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;
  var r = Array.isArray(t);
  return r === Array.isArray(e) ? r ? n.arrayMerge(e, t, n) : mergeObject(e, t, n) : cloneUnlessOtherwiseSpecified(t, n);
}

deepmerge.all = function (e, n) {
  if (!Array.isArray(e)) throw new Error("first argument should be an array");
  return e.reduce(function (e, t) {
    return deepmerge(e, t, n);
  }, {});
};

var deepmerge_1 = deepmerge,
    cjs = deepmerge_1,
    defaultThemes = {
  default: {
    text: {
      primary: "rgba(0, 0, 0, 0.87)",
      secondary: "rgba(0, 0, 0, 0.54)",
      disabled: "rgba(0, 0, 0, 0.38)"
    },
    background: {
      default: "#FFFFFF"
    },
    context: {
      background: "#e3f2fd",
      text: "rgba(0, 0, 0, 0.87)"
    },
    divider: {
      default: "rgba(0,0,0,.12)"
    },
    button: {
      default: "rgba(0,0,0,.54)",
      focus: "rgba(0,0,0,.12)",
      hover: "rgba(0,0,0,.12)",
      disabled: "rgba(0, 0, 0, .18)"
    },
    sortFocus: {
      default: "rgba(0, 0, 0, .54)"
    },
    selected: {
      default: "#e3f2fd",
      text: "rgba(0, 0, 0, 0.87)"
    },
    highlightOnHover: {
      default: "#EEEEEE",
      text: "rgba(0, 0, 0, 0.87)"
    },
    striped: {
      default: "#FAFAFA",
      text: "rgba(0, 0, 0, 0.87)"
    }
  },
  dark: {
    text: {
      primary: "#FFFFFF",
      secondary: "rgba(255, 255, 255, 0.7)",
      disabled: "rgba(0,0,0,.12)"
    },
    background: {
      default: "#424242"
    },
    context: {
      background: "#E91E63",
      text: "#FFFFFF"
    },
    divider: {
      default: "rgba(81, 81, 81, 1)"
    },
    button: {
      default: "#FFFFFF",
      focus: "rgba(255, 255, 255, .54)",
      hover: "rgba(255, 255, 255, .12)",
      disabled: "rgba(255, 255, 255, .18)"
    },
    sortFocus: {
      default: "rgba(255, 255, 255, .54)"
    },
    selected: {
      default: "rgba(0, 0, 0, .7)",
      text: "#FFFFFF"
    },
    highlightOnHover: {
      default: "rgba(0, 0, 0, .7)",
      text: "#FFFFFF"
    },
    striped: {
      default: "rgba(0, 0, 0, .87)",
      text: "#FFFFFF"
    }
  }
},
    createTheme = function createTheme(e, t) {
  var n = 1 < arguments.length && void 0 !== t ? t : {};
  return defaultThemes[e] = cjs(defaultThemes.default, n), defaultThemes[e];
},
    defaultStyles = function defaultStyles(e) {
  return {
    table: {
      style: {
        color: e.text.primary,
        backgroundColor: e.background.default
      }
    },
    tableWrapper: {
      style: {
        display: "table"
      }
    },
    header: {
      style: {
        fontSize: "22px",
        color: e.text.primary,
        backgroundColor: e.background.default,
        minHeight: "56px",
        paddingLeft: "16px",
        paddingRight: "8px"
      }
    },
    subHeader: {
      style: {
        backgroundColor: e.background.default,
        minHeight: "52px"
      }
    },
    head: {
      style: {}
    },
    headRow: {
      style: {
        backgroundColor: e.background.default,
        minHeight: "56px",
        borderBottomWidth: "1px",
        borderBottomColor: e.divider.default,
        borderBottomStyle: "solid"
      },
      denseStyle: {
        minHeight: "32px"
      }
    },
    headCells: {
      style: {
        fontSize: "12px",
        fontWeight: 500,
        color: e.text.primary,
        paddingLeft: "16px",
        paddingRight: "16px"
      },
      activeSortStyle: {
        color: e.text.primary,
        "&:focus": {
          outline: "none"
        },
        "&:hover:not(:focus)": {
          color: e.sortFocus.default
        }
      },
      inactiveSortStyle: {
        "&:focus": {
          outline: "none",
          color: e.sortFocus.default
        },
        "&:hover": {
          color: e.sortFocus.default
        }
      }
    },
    contextMenu: {
      style: {
        backgroundColor: e.context.background,
        fontSize: "18px",
        fontWeight: 400,
        color: e.context.text,
        paddingLeft: "16px",
        paddingRight: "8px",
        transform: "translate3d(0, -100%, 0)",
        transitionDuration: "125ms",
        transitionTimingFunction: "cubic-bezier(0, 0, 0.2, 1)",
        willChange: "transform"
      },
      activeStyle: {
        transform: "translate3d(0, 0, 0)"
      }
    },
    cells: {
      style: {
        paddingLeft: "16px",
        paddingRight: "16px",
        wordBreak: "break-word"
      }
    },
    rows: {
      style: {
        fontSize: "13px",
        color: e.text.primary,
        backgroundColor: e.background.default,
        minHeight: "48px",
        "&:not(:last-of-type)": {
          borderBottomStyle: "solid",
          borderBottomWidth: "1px",
          borderBottomColor: e.divider.default
        }
      },
      denseStyle: {
        minHeight: "32px"
      },
      selectedHighlightStyle: {
        "&:nth-of-type(n)": {
          color: e.selected.text,
          backgroundColor: e.selected.default,
          borderBottomColor: e.background.default
        }
      },
      highlightOnHoverStyle: {
        color: e.highlightOnHover.text,
        backgroundColor: e.highlightOnHover.default,
        transitionDuration: "0.15s",
        transitionProperty: "background-color",
        borderBottomColor: e.background.default,
        outlineStyle: "solid",
        outlineWidth: "1px",
        outlineColor: e.background.default
      },
      stripedStyle: {
        "&:nth-of-type(odd)": {
          color: e.striped.text,
          backgroundColor: e.striped.default
        }
      }
    },
    expanderRow: {
      style: {
        color: e.text.primary,
        backgroundColor: e.background.default
      }
    },
    expanderCell: {
      style: {
        flex: "0 0 48px"
      }
    },
    expanderButton: {
      style: {
        color: e.button.default,
        fill: e.button.default,
        backgroundColor: "transparent",
        borderRadius: "2px",
        transition: "0.25s",
        height: "100%",
        width: "100%",
        "&:hover:enabled": {
          cursor: "pointer"
        },
        "&:disabled": {
          color: e.button.disabled
        },
        "&:hover:not(:disabled)": {
          cursor: "pointer",
          backgroundColor: e.button.hover
        },
        "&:focus": {
          outline: "none",
          backgroundColor: e.button.focus
        },
        svg: {
          margin: "auto"
        }
      }
    },
    pagination: {
      style: {
        color: e.text.secondary,
        fontSize: "13px",
        minHeight: "56px",
        backgroundColor: e.background.default,
        borderTopStyle: "solid",
        borderTopWidth: "1px",
        borderTopColor: e.divider.default
      },
      pageButtonsStyle: {
        borderRadius: "50%",
        height: "40px",
        width: "40px",
        padding: "8px",
        margin: "px",
        cursor: "pointer",
        transition: "0.4s",
        color: e.button.default,
        fill: e.button.default,
        backgroundColor: "transparent",
        "&:disabled": {
          cursor: "unset",
          color: e.button.disabled,
          fill: e.button.disabled
        },
        "&:hover:not(:disabled)": {
          backgroundColor: e.button.hover
        },
        "&:focus": {
          outline: "none",
          backgroundColor: e.button.focus
        }
      }
    },
    noData: {
      style: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: e.text.primary,
        backgroundColor: e.background.default
      }
    },
    progress: {
      style: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: e.text.primary,
        backgroundColor: e.background.default
      }
    }
  };
},
    createStyles = function createStyles(e, t) {
  var n = 0 < arguments.length && void 0 !== e ? e : {},
      r = 1 < arguments.length && void 0 !== t ? t : "default",
      o = defaultThemes[r] ? r : "default";
  return cjs(defaultStyles(defaultThemes[o]), n);
},
    DataTable = React.memo(function (e) {
  function o(e) {
    return He({
      type: "CHANGE_PAGE",
      page: e,
      paginationServer: x,
      visibleOnly: y,
      persistSelectedOnPageChange: De
    });
  }

  var t = e.data,
      n = e.columns,
      r = e.title,
      a = e.actions,
      l = e.keyField,
      i = e.striped,
      c = e.highlightOnHover,
      p = e.pointerOnHover,
      s = e.dense,
      u = e.selectableRows,
      d = e.selectableRowsHighlight,
      f = e.selectableRowsNoSelectAll,
      y = e.selectableRowsVisibleOnly,
      m = e.selectableRowSelected,
      b = e.selectableRowDisabled,
      _ = e.selectableRowsComponent,
      g = e.selectableRowsComponentProps,
      h = e.onRowExpandToggled,
      v = e.onSelectedRowsChange,
      T = e.expandableIcon,
      w = e.onChangeRowsPerPage,
      R = e.onChangePage,
      x = e.paginationServer,
      O = e.paginationServerOptions,
      S = e.paginationTotalRows,
      j = e.paginationDefaultPage,
      C = e.paginationResetDefaultPage,
      E = e.paginationPerPage,
      P = e.paginationRowsPerPageOptions,
      I = e.paginationIconLastPage,
      $ = e.paginationIconFirstPage,
      k = e.paginationIconNext,
      A = e.paginationIconPrevious,
      L = e.paginationComponent,
      F = e.paginationComponentOptions,
      M = e.className,
      H = e.style,
      N = e.responsive,
      D = e.overflowY,
      W = e.overflowYOffset,
      z = e.progressPending,
      q = e.progressComponent,
      B = e.persistTableHead,
      U = e.noDataComponent,
      V = e.disabled,
      G = e.noTableHead,
      Y = e.noHeader,
      K = e.fixedHeader,
      J = e.fixedHeaderScrollHeight,
      Q = e.pagination,
      X = e.subHeader,
      Z = e.subHeaderAlign,
      ee = e.subHeaderWrap,
      te = e.subHeaderComponent,
      ne = e.noContextMenu,
      re = e.contextMessage,
      oe = e.contextActions,
      ae = e.contextComponent,
      le = e.expandableRows,
      ie = e.onRowClicked,
      ce = e.onRowDoubleClicked,
      pe = e.sortIcon,
      se = e.onSort,
      ue = e.sortFunction,
      de = e.sortServer,
      fe = e.expandableRowsComponent,
      ye = e.expandableRowDisabled,
      me = e.expandableRowsHideExpander,
      be = e.expandOnRowClicked,
      _e = e.expandOnRowDoubleClicked,
      ge = e.expandableRowExpanded,
      he = e.expandableInheritConditionalStyles,
      ve = e.defaultSortField,
      Te = e.defaultSortAsc,
      we = e.clearSelectedRows,
      Re = e.conditionalRowStyles,
      xe = e.theme,
      Oe = e.customStyles,
      Se = e.direction,
      je = {
    allSelected: !1,
    selectedCount: 0,
    selectedRows: [],
    sortColumn: ve,
    selectedColumn: {},
    sortDirection: getSortDirection(Te),
    currentPage: j,
    rowsPerPage: E
  },
      Ce = _slicedToArray(React.useReducer(tableReducer, je), 2),
      Ee = Ce[0],
      Pe = Ee.rowsPerPage,
      Ie = Ee.currentPage,
      $e = Ee.selectedRows,
      ke = Ee.allSelected,
      Ae = Ee.selectedCount,
      Le = Ee.sortColumn,
      Fe = Ee.selectedColumn,
      Me = Ee.sortDirection,
      He = Ce[1],
      Ne = O.persistSelectedOnSort,
      De = O.persistSelectedOnPageChange,
      We = x && (De || Ne),
      ze = Q && !z && 0 < t.length,
      qe = L || Pagination,
      Be = React.useMemo(function () {
    return decorateColumns(n);
  }, [n]),
      Ue = React.useMemo(function () {
    return createStyles(Oe, xe);
  }, [Oe, xe]),
      Ve = React.useMemo(function () {
    return fe;
  }, [fe]),
      Ge = React.useMemo(function () {
    return _objectSpread2({}, "auto" !== Se && {
      dir: Se
    });
  }, [Se]),
      Ye = React.useCallback(function (e, t) {
    return ie(e, t);
  }, [ie]),
      Ke = React.useCallback(function (e, t) {
    return ce(e, t);
  }, [ce]);

  useFirstUpdate(function () {
    v({
      allSelected: ke,
      selectedCount: Ae,
      selectedRows: $e
    });
  }, [Ae]), useFirstUpdate(function () {
    R(Ie, S || t.length);
  }, [Ie]), useFirstUpdate(function () {
    w(Pe, Ie);
  }, [Pe]), useFirstUpdate(function () {
    se(Fe, Me);
  }, [Le, Me]), React.useEffect(function () {
    He({
      type: "CLEAR_SELECTED_ROWS",
      selectedRowsFlag: we
    });
  }, [we]), useFirstUpdate(function () {
    o(j);
  }, [j, C]), React.useEffect(function () {
    if (m) {
      var e = t.filter(function (e) {
        return m(e);
      });
      He({
        type: "SELECT_MULTIPLE_ROWS",
        selectedRows: e,
        rows: t,
        mergeSelections: We
      });
    }
  }, [t]), useFirstUpdate(function () {
    if (Q && x && 0 < S) {
      var e = getNumberOfPages(S, Pe),
          t = recalculatePage(Ie, e);
      Ie !== t && o(t);
    }
  }, [S]);
  var Je = React.useMemo(function () {
    return n.reduce(function (e, t) {
      return _objectSpread2(_objectSpread2({}, e), {}, _defineProperty({}, t.selector, t));
    }, {});
  }, [n]),
      Qe = React.useMemo(function () {
    if (de) return t;
    var n = Le && Je[Le];
    if (!n || !n.sortFunction) return sort(t, Le, Me, ue);
    var e = "asc" === Me ? n.sortFunction : function (e, t) {
      return -1 * n.sortFunction(e, t);
    };
    return _toConsumableArray(t).sort(e);
  }, [de, Le, Je, Me, t, ue]),
      Xe = React.useMemo(function () {
    if (!Q || x) return Qe;
    var e = Ie * Pe,
        t = e - Pe;
    return Qe.slice(t, e);
  }, [Ie, Q, x, Pe, Qe]);

  if (Q && !x && 0 < t.length && 0 === Xe.length) {
    var Ze = getNumberOfPages(t.length, Pe),
        et = recalculatePage(Ie, Ze);
    o(et);
  }

  var tt = {
    dispatch: He,
    data: y ? Xe : t,
    allSelected: ke,
    selectedRows: $e,
    selectedCount: Ae,
    sortColumn: Le,
    sortDirection: Me,
    keyField: l,
    contextMessage: re,
    contextActions: oe,
    contextComponent: ae,
    sortServer: de,
    selectableRowsVisibleOnly: y,
    selectableRowSelected: m,
    selectableRowDisabled: b,
    selectableRowsComponent: _,
    selectableRowsComponentProps: g,
    persistSelectedOnSort: Ne,
    expandableIcon: T,
    pagination: Q,
    paginationServer: x,
    paginationServerOptions: O,
    paginationTotalRows: S,
    paginationRowsPerPageOptions: P,
    paginationIconLastPage: I,
    paginationIconFirstPage: $,
    paginationIconNext: k,
    paginationIconPrevious: A,
    paginationComponentOptions: F,
    direction: Se,
    mergeSelections: We
  },
      nt = De || f;
  return React__default.createElement(styled.ThemeProvider, {
    theme: Ue
  }, React__default.createElement(DataTableProvider, {
    initialState: tt
  }, React__default.createElement(ResponsiveWrapper, _extends({
    responsive: N,
    className: M,
    style: H,
    overflowYOffset: W,
    overflowY: D
  }, Ge), !Y && React__default.createElement(TableHeader, {
    title: r,
    actions: a,
    showMenu: !ne
  }), X && React__default.createElement(TableSubheader, {
    align: Z,
    wrapContent: ee
  }, te), React__default.createElement(TableWrapper, null, z && !B && React__default.createElement(ProgressWrapper, null, q), React__default.createElement(TableStyle, {
    disabled: V,
    className: "rdt_Table",
    role: "table"
  }, !G && (!!B || 0 < t.length && !z) && React__default.createElement(TableHead, {
    className: "rdt_TableHead",
    role: "rowgroup"
  }, React__default.createElement(TableHeadRow, {
    className: "rdt_TableHeadRow",
    role: "row",
    dense: s,
    disabled: z || 0 === t.length
  }, u && (nt ? React__default.createElement(CellBase, {
    style: {
      flex: "0 0 48px"
    },
    role: "columnheader"
  }) : React__default.createElement(TableColCheckbox, {
    role: "columnheader"
  })), le && !me && React__default.createElement(TableColExpander, null), Be.map(function (e) {
    return React__default.createElement(TableCol, {
      key: e.id,
      column: e,
      sortIcon: pe
    });
  }))), 0 < !t.length && !z && React__default.createElement(NoDataWrapper, null, U), z && B && React__default.createElement(ProgressWrapper, null, q), !z && 0 < t.length && React__default.createElement(TableBody, {
    fixedHeader: K,
    fixedHeaderScrollHeight: J,
    hasOffset: D,
    offset: W,
    className: "rdt_TableBody",
    role: "rowgroup"
  }, Xe.map(function (e, t) {
    var n = isEmpty(e[l]) ? t : e[l],
        r = isRowSelected(e, $e, l),
        o = le && ge && ge(e),
        a = le && ye && ye(e);
    return React__default.createElement(TableRow, {
      id: n,
      key: n,
      keyField: l,
      row: e,
      columns: Be,
      selectableRows: u,
      expandableRows: le,
      striped: i,
      highlightOnHover: c,
      pointerOnHover: p,
      dense: s,
      expandOnRowClicked: be,
      expandOnRowDoubleClicked: _e,
      expandableRowsComponent: Ve,
      expandableRowsHideExpander: me,
      onRowExpandToggled: h,
      defaultExpanderDisabled: a,
      defaultExpanded: o,
      inheritConditionalStyles: he,
      onRowClicked: Ye,
      onRowDoubleClicked: Ke,
      conditionalRowStyles: Re,
      selected: r,
      selectableRowsHighlight: d
    });
  })))), ze && React__default.createElement(qe, {
    onChangePage: o,
    onChangeRowsPerPage: function onChangeRowsPerPage(e) {
      var t = S || Xe.length,
          n = getNumberOfPages(t, e),
          r = recalculatePage(Ie, n);
      x || o(r), He({
        type: "CHANGE_ROWS_PER_PAGE",
        page: r,
        rowsPerPage: e
      });
    },
    rowCount: S || t.length,
    currentPage: Ie,
    rowsPerPage: Pe
  }))));
});

DataTable.propTypes = propTypes$1, DataTable.defaultProps = defaultProps, exports.createTheme = createTheme, exports.default = DataTable, exports.defaultThemes = defaultThemes;